;(function(window, document, undefined) {
  'use strict';
var Deferred = (function(){
  function Deferred(){
    var def = this;
    /**
     * @instance
     * @memberof Flybits.Deferred
     * @member {external:Promise} promise Instance of an ES6 Promise to be fulfilled.
     */
    this.promise = new Promise(function(resolve,reject){
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} resolve Callback to be invoked when the asychronous task that initiated the promise is successfully completed.
       */
      def.resolve = resolve;
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} reject Callback to be invoked when the asychronous task that initiated the promise has failed to complete successfully.
       */
      def.reject = reject;
    });

    this.then = this.promise.then.bind(this.promise);
    this.catch = this.promise.catch.bind(this.promise);
  }

  Deferred.settlePromises = Deferred.prototype.settlePromises = function(promisesArr){
    var reflectedArr = promisesArr.map(function(promise){
      return promise.then(function(successResult){
        return {
          result: successResult,
          status: 'resolved'
        };
      },function(errorResult){
        return {
          result: errorResult,
          status: 'rejected'
        };
      });
    });
    return Promise.all(reflectedArr);  
  };

  return Deferred;
})();

var Validation = (function(){
  function Validation(){
    this.state = true;
    this.errors = [];

    this.stacktrace = "";

    this.setStackTrace();
  }

  Validation.prototype = {
    addError: function(header,message,detailsObj){
      this.state = false;
      var retObj = {
        header: header,
        message: message
      };
      if(detailsObj){
        retObj.context = detailsObj.context;
        retObj.code = detailsObj.code;
        retObj.serverCode = detailsObj.serverCode;
      }
      this.errors.push(retObj);

      return this;
    },
    firstError: function(){
      if(this.errors.length > 0){
        return this.errors[0];
      }
      return null;
    },
    merge: function(validation){
      Array.prototype.push.apply(this.errors,validation.errors);
      this.state = this.errors.length < 1;

      return this;
    },
    setStackTrace: function(){
      var flyError = new Error();
      flyError.name = "FlybitsError";
      this.stacktrace = flyError.stack;
      if(this.stacktrace){
        this.stacktrace = this.stacktrace.split('\n').filter(function(str){
          return str.indexOf('Validation') < 0;
        }).join('\n');
      }
      return this;
    },
    toJSON: function(){
      return {
        state: this.state,
        errors: this.errors,
        stacktrace: this.stacktrace
      };
    }
  };

  Validation.prototype.type = Validation.type = {};
  Validation.prototype.type.MALFORMED = Validation.type.MALFORMED = 1000;
  Validation.prototype.type.INVALIDARG = Validation.type.INVALIDARG = 1001;
  Validation.prototype.type.MISSINGARG = Validation.type.MISSINGARG = 1002;
  Validation.prototype.type.NOTFOUND = Validation.type.NOTFOUND = 1003;
  Validation.prototype.type.CONNECTIONERROR = Validation.type.CONNECTIONERROR = 1004;
  Validation.prototype.type.UNAUTHENTICATED = Validation.type.UNAUTHENTICATED = 1005;
  Validation.prototype.type.RETRIEVALERROR = Validation.type.RETRIEVALERROR = 1006;
  Validation.prototype.type.NOTSUPPORTED = Validation.type.NOTSUPPORTED = 1007;
  Validation.prototype.type.UNEXPECTED = Validation.type.UNEXPECTED = 1008;

  return Validation;
})();

/**
 * @classdesc Base class from which all core Flybits models are extended.
 * @class
 * @param {Object} serverObj Raw Flybits core model `Object` directly from API.
 */
 var BaseModel = (function(){
  var BaseModel = function(serverObj){
    /**
     * @instance
     * @memberof BaseModel
     * @member {string} id Parsed ID of the Flybits core model.
     */
    this.id;

    if(serverObj && serverObj.id){
      this.id = serverObj.id;
    }
  };

  BaseModel.prototype.constructor = BaseModel;

  BaseModel.prototype.reqKeys = {
    id: 'id'
  };

  return BaseModel;
})();

var Path = (function(){
  function Path(){
    this.nodes = [];
  };

  Path.prototype.getNode = function(className){
    return this.nodes.filter(function(obj){
      return Flybits.util.Obj.functionName(obj.constructor) === className;
    })[0];
  };

  Path.prototype.append = function(obj){
    this.nodes.push(obj);
    return this;
  };

  Path.prototype.serialize = function(){
    var pathStr = "";
    for(var i = 0; i < this.nodes.length; i++){
      pathStr += '/' + this.nodes[i]._pathName;
      if(this.nodes[i].id){
        pathStr += '/' + this.nodes[i].id;
      }
    }
    
    return pathStr;
  };

  return Path;
})();

var Content = ( function(){
  var ApiUtil = Flybits.util.Api;

  /**
   * @typedef LocalizedObject
   * @memberof Flybits.Content
   * @type Object
   * @property {string} name Name of the Content instance.
   * @property {string} description Description of the Content instance.
   */

  function Content( serverObj ){
    BaseModel.call( this, serverObj );
    this.fromJSON( serverObj );
  }

  Content.prototype = Object.create( BaseModel.prototype );
  Content.prototype.constructor = Content;

  Content.prototype.types = Content.types = {
    DEFAULT: 'default',
    SURVEY: 'SurveyQuestions'
  };
  Content.prototype._pathName = Content._pathName = 'content/instances';

  Content.prototype.reqKeys = Content.reqKeys = {
    name: 'name',
    description: 'description',
    createdDate: 'createdAt',
    lastModifiedDate: 'modifiedAt',
    id: 'id'
  };

  /***** Localizable function overloading *****/
  Content.prototype._fromLocaleJSON = function( serverObj ) {
    var retObj = {
      name: serverObj.name,
      description: serverObj.description
    };

    return retObj;
  };

  Content.prototype._toLocaleJSON = function ( appObj ) {
    var retObj = {
      name: appObj.name,
      description: appObj.description
    };

    return retObj;
  };

  Content.prototype.parseContents = function(serverObj){
    var paging = ApiUtil.parsePaging( serverObj );
    var contentObj = this;
    
    var allContentData = serverObj.data.map( function(obj){
      var routePath = new Path().append(contentObj);
      try{
        return new Flybits.ContentData( obj, routePath );
      } catch(e){
        console.error(e);
        throw new Validation().addError("Parse Failed","Failed to parse Content data model.",{
          code: Validation.type.MALFORMED,
          context: obj
        });
      }
    });

    return {
      result: allContentData,
      nextPageFn: ApiUtil.createNextPageCall( Flybits.api.ContentData.getAll, {
        contentID: contentObj.id
      }, paging )
    };
  };

  /**
   * Retrieve the data from the Content model instance.
   * @memberof Flybits.Content
   * @instance
   * @function getData
   * @return {external:Promise<Object,Flybits.Validation>} Promise that resolves with the Content instance's JSON payload object.
   */
  Content.prototype.getData = function(){
    var obj = this;
    if(this.data && this.data.result && this.data.result.length > 0){
      return Promise.resolve(this.data.result[0].payload);
    } else{
      var def = new Flybits.Deferred();
      Flybits.api.ContentData.getAll({
        contentID: this.id
      }).then(function(respObj){
        if(respObj && respObj.result && respObj.result.length > 0){
          obj.data = respObj;
          def.resolve(respObj.result[0].payload);
        } else{
          def.resolve();
        }
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    }
  };

  /***** Serializable function overloading *****/
  Content.prototype.fromJSON = function(serverObj){
    serverObj = serverObj || {};
    var obj = this;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} id - id value of the content instance.
     */
    obj.id = serverObj.id;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} tenantID - id value of the tenant(project) of instance
     */
    obj.tenantID = serverObj.tenantId;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} templateID - id value of the content template of the fetched content instance.
     */
    obj.templateID = serverObj.templateId;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} type - content template type from which this instance was created from.
     */
    obj.type = serverObj.templateType || Content.types.DEFAULT;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} iconURL - URL of the icon image associated with this content instance.
     */
    obj.iconURL = serverObj.iconUrl;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {Date} createdDate - Date of model creation.
     */
    obj.createdDate = serverObj.createdAt? new Date(serverObj.createdAt*1000):null;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {Date} lastModifiedDate - Date of last modification of model.
     */
    obj.lastModifiedDate = serverObj.modifiedAt? new Date(serverObj.modifiedAt*1000):null;
    /**
     * @instance
     * @memberof Flybits.Content
     * @see Flybits.Content.LocalizedObject
     * @member {Object} locales - Map of available locale keys to {@link Flybits.Content.LocalizedObject} objects containing information.
     * @example
     * { 
     *   en: {
     *     name: 'Falafel',
     *     description: 'Falafel is good'
     *   },
     *   fr: {
     *     name: 'Falafel',
     *     description: 'Falafel est bon'
     *   }
     * }
     */
    obj.locales = {};

    var localeKeys = serverObj.localizations ? Object.keys(serverObj.localizations) : [];
    localeKeys.forEach( function( key ) {
      obj.locales[key] = obj._fromLocaleJSON( serverObj.localizations[key] );
    });

    obj.name = obj.locales.en?obj.locales.en.name:'';
    obj.description = obj.locales.en?obj.locales.en.description:'';

    // if( localeKeys.length > 0 && this.defaultLang ) {
    //   this.defaultLocaleObj = this.locales[ this.defaultLang ];
    // }
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} 
     */
    obj.linkedFields = serverObj.linkedFields;

    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string[]}
     */
    obj.labels = serverObj.labels || [];

    obj.data = serverObj.content? this.parseContents(serverObj.content):undefined;

    obj.renderType = serverObj.renderType;
    
    obj.defaultUI = serverObj.defaultUIConfig?serverObj.defaultUIConfig:{
      layout: "",
      layoutHTML: "",
      styleCSS: "",
      styleCSSURL: ""
    };

    obj.detailsUI = serverObj.detailsUIConfig?serverObj.detailsUIConfig:{
      layout: "",
      layoutHTML: "",
      styleCSS: "",
      styleCSSURL: ""
    };
  };

  Content.prototype.toJSON = function(){
    var obj = this;
    
    var retObj = {
      iconUrl: obj.iconURL,
      localizations: {
        en: {
          name: obj.name,
          description: obj.description
        }
      },
      labels: obj.labels,
      defaultUIConfig: this.defaultUI,
      detailsUIConfig: this.detailsUI
    };

    if(this.defaultUI && (this.defaultUI.layout || this.defaultUI.layoutHTML)){
      retObj.renderType = 'html';
    } else {
      retObj.renderType = "";
    }

    if(obj.createdDate){
      retObj.createdAt = Math.round(obj.createdDate.getTime()/1000);
    }
    if(obj.lastModifiedDate){
      retObj.modifiedAt = Math.round(obj.lastModifiedDate.getTime()/1000);
    }

    /* id rendering: thrown in for just safety purpose
     * id validations(content instance, content template, tenant) moved to the content API
     * id is not passed in the body of JSON (PUT, POST) requests anymore (Part of Header and URL)
     */
    if( obj.id ) {
      retObj.id = obj.id;
    }

    if(!obj.id && obj.data){
      retObj.data = obj.data;
    }

    if( obj.tenantID ) {
      retObj.tenantId = obj.tenantID;
    }

    if( obj.templateID ) {
      retObj.templateId = obj.templateID;
    }

    if( obj.type ){
      retObj.templateType = obj.type;
    }

    if(obj.metadata){
      retObj.metadata = obj.metadata;
    } else{
      retObj.metadata = {};
    }

    return retObj;
  };

  Content.getInstance = function(serverObj){
    var hasQuestions = serverObj.content && serverObj.content.data && serverObj.content.data.length && serverObj.content.data[0].questions;

    if((serverObj.templateType === Content.types.SURVEY && serverObj.surveyMetadata) || hasQuestions){
      return new Flybits.Survey(serverObj);
    } else{
      return new Content(serverObj);
    }
  };

  return Content;
})();
var LoadingView = Vue.extend({
  template:'#view-loading',
});
Vue.component('loading-view',LoadingView);
var LoaderBar = Vue.extend({
  template:'#loader-bar',
});
Vue.component('loader-bar',LoaderBar);

var HeaderBar = (function(){
  return Vue.extend({
    template:'#header-bar',
    props: {
      title: {
        default: 'Concierge Manager'
      }
    },
    data: function(){
      return {
        logoURL: 'images/logoIcon.png',
        isAdmin: App.store.state.user.isAdmin,
        version: App.vm.version
      };
    },
    computed: {
      userInitials: function(){
        var str = '';
        if(App.store.state.user.user && App.store.state.user.user.firstName){
          str += App.store.state.user.user.firstName.charAt(0);
        }
        if(App.store.state.user.user && App.store.state.user.user.lastName){
          str += App.store.state.user.user.lastName.charAt(0);
        }
        return str.toUpperCase();
      },
      userFullName: function(){
        if(App.store.state.user.user){
          return  App.store.state.user.user.firstName + ' ' +
                  App.store.state.user.user.lastName;
        }
        return '';
      },
      isFlybitsUser: function(){
        return App?.store?.state?.user?.user?.email?.indexOf('@flybits.com') > -1;
      }
    },
    methods: {
      logout: function(){
        App.store.dispatch('user/logout');
        App.router.replace({
          name: 'login'
        });
      },
      gotoSettings: function(){
        App.router.push({
          name: 'settings'
        });
      }
    },
    mounted: function(){
    }
  });
})();
Vue.component('header-bar',HeaderBar);

var EditableDisplayfield = (function(){
  return Vue.extend({
    template:'#editable-displayfield',
    props: ['value', 'placeholder'],
    data: function(){
      return {
        proxyVal: '',

      }
    },
    watch: {
      value: function(newVal, oldVal){
        if(this.proxyVal !== newVal){
          this.proxyVal = newVal;
        }
      },
      proxyVal: function(newVal, oldVal){
        if(this.value !== newVal){
          this.$emit('input', newVal);
          this.resize();
        }
      }
    },
    methods: {
      focusEdit: function(){
        this.$refs.textedit.focus();
      },
      resize: function(){
        this.$refs.textedit.style.width = (this.proxyVal.length + 5) + 'ch';
      }
    },
    mounted: function(){
      if(this.value){
        var view = this;
        this.proxyVal = this.value;
        this.resize();
      }
    }
  });
})();
Vue.component('editable-displayfield',EditableDisplayfield);

var TextToggle = (function(){
  return Vue.extend({
    template:'#text-toggle',
    props: {
      options: {
        type: Array,
        default: function(){
          return [{
            label: 'Off',
            key: 'off'
          },{
            label: 'On',
            key: 'on'
          }]
        }
      },
      value: {
        type: Object
      }
    },
    methods: {
      isSelected: function(opt){
        return opt.key === this.value.key;
      },
      select: function(opt){
        this.$emit('input', opt);
        this.$emit('change', opt);
      }
    }
  });
})();
Vue.component('text-toggle',TextToggle);

var ToggleView = Vue.extend({
  template:'#toggle-view',
  props:['value','label','inverted'],
  methods:{
    toggle:function(){
      this.$emit('input',!this.value);
    }
  }
});
Vue.component('toggle-view',ToggleView);
var LabelPicker = (function(){
  return Vue.extend({
    template:'#label-picker',
    props: {
      value: {
        type: Array
      },
      available: {
        type: Array,
        default: function(){return[];}
      },
      onlyAvailable: {
        type: Boolean,
        default: false
      }
    },
    data: function(){
      return {
        tmpNewLabel: '',
        inputMode: false,
        removeLastMode: false
      };
    },
    watch: {
      tmpNewLabel: function(newVal, oldVal){
        this.removeLastMode = false;
      }
    },
    methods: {
      addLabel: function(str){
        var view = this;
        var inputLabel = this.tmpNewLabel || str;

        if(inputLabel){
          this.value.push(inputLabel);
          this.$emit('input', this.value);
          this.$emit('change', this.value);
          this.tmpNewLabel = '';
          Vue.nextTick(function(){
            view.removeLastMode = true;
          });
        }
      },
      removeLabel: function(str){
        App.util.Obj.removeObject(this.value, str);
        this.$emit('input', this.value);
        this.$emit('change', this.value);
      },
      removeLastLabel: function(){
        if(!this.tmpNewLabel && this.removeLastMode){
          this.value.pop();
          this.$emit('input', this.value);
          this.$emit('change', this.value);
        } else if(!this.tmpNewLabel && !this.removeLastMode){
          this.removeLastMode = true;
        }
      },
      toggleInputMode: function(){
        var view = this;
        if(this.onlyAvailable){
          return;
        }

        this.inputMode = !this.inputMode;
        if(!this.inputMode){
          this.tmpNewLabel = '';
        } else{
          Vue.nextTick(function(){
            view.$refs.labelinput.focus();
          })
        }
      }
    }
  });
})();
Vue.component('label-picker',LabelPicker);

var noPreviewStyleString = `
  .content-preview-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 128px;
    margin: 16px 0;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.1);
  }

  .content-preview-card__content {
    padding: 10px 10px 14px 10px;
  }

  .content-preview-card--no-preview .content-preview-card__description {
    padding: 20px 0;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    color: #82899b;
  }

  .content-preview-card__description {
    margin-top: 10px;
    font-size: 10px;
    font-weight: 400;
    line-height: 13px;
    color: #848688;
    overflow-wrap: break-word;
  }
`;

var noPreviewHTML = `
  <div class="content-preview-card content-preview-card--no-preview" aria-label="content preview">
  <div class="content-preview-card__content">
    <div class="content-preview-card__description" aria-label="content description">No preview available</div>
  </div>
  </div>
`;

var PhonePreview = (function(){
  
  var stripContent = function(content){
    var data = content.data.result && Array.isArray(content.data.result)?
               content.data.result[0].toJSON() : content.data;
    App.util.Content.flattenLocales(data);
    var retObj = {
      id: content.id,
      data: data,
      uiTemplate: '',
      style: '',
      styleStr: ''
    };

    var uiObj = content.defaultUI || content.detailsUI || {};
    retObj.uiTemplate = uiObj.layoutHTML || noPreviewHTML;
    retObj.style = uiObj.styleCSSURL;
    retObj.styleStr = uiObj.layoutHTML ? uiObj.styleCSS : noPreviewStyleString;
    return retObj;
  };

  var setInject = function(iframe, payload){
    var def = new Deferred();
    var callback = function(){
      iframe.contentWindow.postMessage(payload, '*');
      def.resolve();
    };

    iframe.addEventListener('load', callback);
    iframe.setAttribute('src', App.store.state.config.res.ZONEAPP);
    def.promise.then(function(){
      iframe.removeEventListener('load', callback);
    });
  };

  return Vue.extend({
    template:'#phone-preview',
    props: ['zone','module', 'changeHash','content'],
    data: function(){
      return {
        timer: null,
        time: null,
        isLoading: false,
      };
    },
    computed: {
      timeStr: function(){
        var retStr = '';
  
        if(this.time){
          retStr = App.util.Obj.zero2Pad(this.time.getHours()) + ':' + App.util.Obj.zero2Pad(this.time.getMinutes());
        }
  
        return retStr;
      },
      zonePayload: function(){
        if(this.zone){
          var vm = this;
          var payload = {
            name: this.zone.name,
            containers: this.zone.modules.map(function(module){
              return {
                name: module.name,
                layoutStr: module.layoutHTML,
                layout: module.layoutName,
                style: module.styleCSSURL,
                styleStr: module.styleCSS,
                query: module.toJSON().query,
                content: vm.getResolvedContents(module).map(function(c){
                  return stripContent(c);
                })
              }
            })
          };
          
          return payload;
        }
        return;
      },
      modulePayload: function(){
        if(this.module){
          var payload = {
            name: 'tmp' + App.util.Obj.guid(1),
            containers: [{
              name: this.module.name,
              layoutStr: this.module.layoutHTML,
              layout: this.module.layoutName,
              style: this.module.styleCSSURL,
              styleStr: this.module.styleCSS,
              query: this.module.toJSON().query,
              content: this.getResolvedContents(this.module).map(function(c){
                return stripContent(c);
              })
            }]
          }
          return payload;
        }
        return;
      }
    },
    watch: {
      changeHash: function(newVal, oldVal){
        console.log('> newVal', newVal);
        this.debouncedLoad();
      },
      zonePayload: function(newVal, oldVal){
        var vm = this;
        this.debouncedLoad();
      },
      modulePayload: function(newVal, oldVal){
        var vm = this;
        this.debouncedLoad();
      }
    },
    methods: {
      getResolvedContents: function(module){
        return this.content || App.store.getters['content/getContentByLabels'](module.labels) || [];
      },
      startClock: function(){
        var view = this;
        this.endClock();
        console.log('> start clock');
        view.time = new Date();
        this.timer = setInterval(function(){
          view.time = new Date();
        }, 60000);
      },
      endClock: function(){
        clearInterval(this.timer);
        this.timer = null;
      },
      loadZone: function(){
        var view = this;
        var iframe = this.$refs.zoneframe;
        this.isLoading = true;
        setTimeout(function(){
          if(view.zone){
            setInject(iframe, view.zonePayload);
          } else if(view.module){
            setInject(iframe, view.modulePayload);
          }
        },200);
        setTimeout(function(){
          view.isLoading = false;
        },300);
      }
    },
    mounted: function(){
      this.startClock();
      var vm = this;
      this.debouncedLoad = App.util.Obj.debounce(function(){
        vm.loadZone();
      }, 200);

      if(this.changeHash){
        var vm = this;
        Vue.nextTick(function(){
          vm.loadZone();
        });
      }
    }
  });
})();
Vue.component('phone-preview',PhonePreview);

var CardPlaceholder = (function(){
  return Vue.extend({
    template:'#card-placeholder',
    data: function(){
      return {
        block: 0
      };
    },
    methods: {
      /** inclusive */
      getRandomInt: function(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      } 
    },
    mounted: function(){
      this.block = this.getRandomInt(0,3);
    }
  });
})();
Vue.component('card-placeholder',CardPlaceholder);

var LayoutEditor = (function(){
  var BASIC = {label:'Basic', key: 'basic'};
  var ADVANCED = {label: 'Advanced', key: 'advanced'};

  return Vue.extend({
    template:'#layout-editor',
    props: ['module'],
    data: function(){
      return {
        editModeObj: BASIC,
        modes: [BASIC, ADVANCED],
        isHTMLEditorOpen: true,
        isCSSEditorOpen: true,
      };
    },
    computed: {
      htmlSize: function(){
        if(!this.isHTMLEditorOpen){
          return 'closed';
        } else if(this.isHTMLEditorOpen && this.isCSSEditorOpen){
          return 'half';
        } else if(this.isHTMLEditorOpen && !this.isCSSEditorOpen){
          return 'full';
        }
      },
      cssSize: function(){
        if(!this.isCSSEditorOpen){
          return 'closed';
        } else if(this.isCSSEditorOpen && this.isHTMLEditorOpen){
          return 'half';
        } else if(this.isCSSEditorOpen && !this.isHTMLEditorOpen){
          return 'full';
        }
      },
      editMode: function(){
        return this.editModeObj.key;
      },
      layouts: function(){
        return App.store.state.component.moduleTemplates;
      }
    },
    methods: {
      expandEditor: function(editorCode){
        if(editorCode === 'html'){
          this.isHTMLEditorOpen = !this.isHTMLEditorOpen;
        } else if(editorCode === 'css'){
          this.isCSSEditorOpen = !this.isCSSEditorOpen;
        }
      },
      emitChange: function(){
        this.$emit('change');
      },
      emitDone: function(){
        this.$emit('done');
      },
      selectLayout: function(layout){
        this.module.layoutHTML = layout.html;
        this.module.styleCSS = layout.css
        this.emitChange();
        this.emitDone();
      }
    }
  });
})();
Vue.component('layout-editor',LayoutEditor);

var CodeEditor = (function(){
  var BEAUTY = {
    "indent_size": "2",
    "indent_char": " ",
    "max_preserve_newlines": "-1",
    "preserve_newlines": false,
    "keep_array_indentation": false,
    "break_chained_methods": false,
    "indent_scripts": "normal",
    "brace_style": "collapse",
    "space_before_conditional": true,
    "unescape_strings": false,
    "jslint_happy": false,
    "end_with_newline": false,
    "wrap_line_length": "0",
    "indent_inner_html": true,
    "comma_first": false,
    "e4x": false,
    "indent_empty_lines": false,
  };

  /**
   * @param {string} language Language type of the code (eg. js, html, css). 
   */
  return Vue.extend({
    template:'#code-editor',
    props: ['value', 'language'],
    data: function(){
      return {
        editor: null,
        tmpChange: '',
      }
    },
    watch: {
      value: function(newVal, oldVal){
        if(newVal !== this.tmpChange){
          this.editor.updateCode(this.beautify(newVal));
        }
      }
    },
    methods: {
      beautify: function(str){
        if(this.language === 'js'){
          return js_beautify(str, BEAUTY);
        } else if(this.language === 'html'){
          return html_beautify(str, BEAUTY);
        } else if(this.language === 'css'){
          return css_beautify(str, BEAUTY);
        }
        return str;
      },
      sanitize: function(str){
        return str.split('\n').join('');
      }
    },
    mounted: function(){
      var view = this;
      this.editor = new CodeFlask(this.$refs.code,{
        language: this.language,
        lineNumbers: true,
      });
      if(this.value){
        this.editor.updateCode(this.beautify(this.value));
      }

      this.editor.onUpdate(function(code){
        view.tmpChange = view.sanitize(code);
        view.$emit('input', view.tmpChange);
      });
    }
  });
})();
Vue.component('code-editor',CodeEditor);

var ConfirmButton = (function(){
  return Vue.extend({
    template:'#confirm-button',
    props: ['label'],
    data: function(){
      return {
        isConfirm: false,
      }
    },
    methods: {
      confirm: function(){
        this.isConfirm = true;
      },
      cancel: function(){
        this.isConfirm = false;
      },
      action: function(){
        this.$emit('action');
        this.isConfirm = false;
      }
    }
  });
})();
Vue.component('confirm-button',ConfirmButton);

var BaseRoute = (function(){
  function BaseRoute(opts){
    opts = opts || {};
    if(opts.beforeRouteEnter){
      this.extBeforeRouteEnter = opts.beforeRouteEnter;
      delete opts.beforeRouteEnter;
    }
    Flybits.util.Obj.extend(this, opts,{
      mutate: true
    });
  };
  
  BaseRoute.prototype = {
    beforeRouteEnter: function(to, from, next){
      var route = to.matched[0]?to.matched[0].components.default:null;
      setTimeout(function(){
        App.ready.then(function(){
          if(route && route.extBeforeRouteEnter){
            route.extBeforeRouteEnter(to, from, next);
          } else{
            next();
          }
        });
      },1);
    }
  };
  
  return BaseRoute;
})();
var AuthenticatedRoute = (function(){
  function AuthenticatedRoute(opts){
    BaseRoute.call(this, opts);
  }

  AuthenticatedRoute.prototype = Object.create( BaseRoute.prototype );
  AuthenticatedRoute.prototype.constructor = AuthenticatedRoute;

  AuthenticatedRoute.prototype.beforeRouteEnter = function(to, from, next){
    var route = to.matched[0]?to.matched[0].components.default:null;
    setTimeout(function(){
      App.ready.then(function(){
        Flybits.Session.resolveSession().then(function(){
          App.store.dispatch('user/resolveUser', true);
          if(route && route.extBeforeRouteEnter){
            route.extBeforeRouteEnter(to, from, next);
          } else{
            next();
          }
        }).catch(function(e){
          Flybits.Session.clearSession();
          App.authClient.request();          
        });
      });
    },1);
  };

  return AuthenticatedRoute;
})();
var ConciergeManager = (function(){
  return new AuthenticatedRoute({
    template:'#concierge-manager',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        Deferred.settlePromises([
          App.store.dispatch('content/hydrate'),
          App.store.dispatch('zone/hydrate')
        ]).then(function(){
          vm.zones = App.store.state.zone.zones;
          vm.selectZone(vm.zones[0]);
        }).catch(function(e){
          console.error(e);
          App.toast('Failed to load data', 'error');
        }).then(function(){
          vm.isLoading = false;
        });
      })
    },
    data: function(){
      return {
        isLoading: true,
        selectedModule: null,
        selectedZone: null,
        zones: [],
        changeHash: '',
        queryEditModes: Flybits.Module.QUERYMODES
      }
    },
    methods: {
      getPagingSize: function(module){
        return module.contentPaging?.limit || module.paging?.limit;
      },
      setPagingSize: function(module, value){
        module.contentPaging.limit = +value;
        module.paging.limit = +value;
      },
      toggleHash: function(){
        this.changeHash = App.util.Obj.guid();
      },
      selectZone: function(zone){
        if(this.selectZone !== zone){
          this.selectedZone = zone;
          if(zone){
            this.changeHash = App.util.Obj.hash(JSON.stringify(zone.toJSON()));
          }
        }
      },
      editModuleLayout: function(module){
        this.selectedModule = module;
        if(module){
          this.selectZone();
          this.changeHash = App.util.Obj.hash(JSON.stringify(module.toJSON()));
        } else{
          this.selectZone(this.zones[0]);
        }
      },
      addZone: function(){
        this.zones.push(new Flybits.Zone())
      },
      removeZone: function(zone){
        App.util.Obj.removeObject(this.zones, zone);
      },
      addModule: function(zone){
        zone.modules.push(new Flybits.Module());
      },
      removeModule: function(zone, module){
        App.util.Obj.removeObject(zone.modules, module);
      },
      adjustModuleQuery: function(module){
        module.updateQueryMode();
      },
      moveTo: function(zone, module, fromIndex, toIndex){
        if(!zone || !module || fromIndex === toIndex || 
           fromIndex < 0 || toIndex < 0 || 
           fromIndex > zone.modules.length || toIndex > zone.modules.length){
          return;
        }

        zone.modules.splice(fromIndex, 1);
        zone.modules.splice(toIndex, 0, module);
      },
      save: function(){
        var vm = this;
        App.evt.emit(App.actions.LOADING, true);
        App.store.dispatch('zone/saveAll').then(function(){
          vm.zones = App.store.state.zone.zones;
          vm.selectZone(vm.zones[0]);
          vm.editModuleLayout();
        }).catch(function(e){
          App.toast('failed to save configuration', 'error');
          console.error(e);  
        }).then(function(){
          App.evt.emit(App.actions.LOADING, false);
        })
      }
    },
    mounted: function(){
      var view = this;
      var nodes = view.$el.querySelectorAll('.module-item');
      nodes = [].slice.call(nodes);
    }
  });

})();
Vue.component('concierge-manager',ConciergeManager);
var ExperienceTemplates = (function(){

  return new AuthenticatedRoute({
    template:'#experience-templates',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.loadFrame();
      })
    },
    beforeRouteLeave: function(to, from, next){
      window.removeEventListener('message', this.loadHandlerFn);
      next();
    },
    data: function(){
      return {
        loadHandlerFn: null
      }
    },
    computed: {
      injectPayload: function(){
        return {
          env: App.store.getters['config/envStr'],
          host: App.store.state.config.HOST,
          token: Flybits.Session.userToken
        };
      }
    },
    methods: {
      loadFrame: function(){
        var vm = this;
        var frame = this.$refs.frame;

        this.loadHandlerFn = function(evt){
          if(evt?.data?.type === 'flb.journeytemplatemanager.ready'){
            console.log('> flb.journeytemplatemanager.ready');
            vm.inject();
          }
        }
        window.addEventListener('message', this.loadHandlerFn);
        frame.setAttribute('src',App.store.state.config.JOURNEYMANAGER);
      },
      inject: function(){
        var frame = this.$refs.frame;
        frame.contentWindow.postMessage(this.injectPayload, App.store.state.config.JOURNEYMANAGER);
      },
    }
  });

})();
Vue.component('experience-templates',ExperienceTemplates);
var ComponentTemplates = (function(){

  return new AuthenticatedRoute({
    template:'#component-templates',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.loadFrame();
      })
    },
    beforeRouteLeave: function(to, from, next){
      window.removeEventListener('message', this.loadHandlerFn);
      next();
    },
    data: function(){
      return {
        loadHandlerFn: null
      }
    },
    computed: {
      injectPayload: function(){
        return {
          env: App.store.getters['config/envStr'],
          host: App.store.state.config.HOST,
          token: Flybits.Session.userToken
        };
      }
    },
    methods: {
      loadFrame: function(){
        var vm = this;
        var frame = this.$refs.frame;

        this.loadHandlerFn = function(evt){
          if(evt?.data?.type === 'flb.componentmanager.ready'){
            console.log('> flb.componentmanager.ready');
            vm.inject();
          }
        }
        window.addEventListener('message', this.loadHandlerFn);
        frame.setAttribute('src',App.store.state.config.COMPONENTMANAGER);
      },
      inject: function(){
        var frame = this.$refs.frame;
        frame.contentWindow.postMessage(this.injectPayload, App.store.state.config.COMPONENTMANAGER);
      },
    }
  });

})();
Vue.component('experience-templates',ExperienceTemplates);
var SettingsPage = (function(){

  return {
    template:'#settings-page',
  };

})();
Vue.component('settings-page',SettingsPage);
var SplashPage = (function(){

  return new BaseRoute({
    template: '#splash-page',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        App.store.dispatch('user/resolveUser', true).then(function(){
          App.router.replace({
            name: 'conciergeManager'
          });
        }).catch(function(e){
          console.error(e);
          Flybits.Session.clearSession();
          App.authClient.request();
        });
      })
    }
  });

})();
Vue.component('splash-page',SplashPage);
var AuthCallback = (function(){

  return new BaseRoute({
    template:'#auth-callback',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        App.evt.emit(App.actions.LOADING, true);
        App.authClient.requestSPAuthz().then(function(res){
          if(res && res.accessToken){
            Flybits.Session.setUserToken(res.accessToken);
            App.store.dispatch('user/resolveUser');
            App.router.replace({
              name: 'conciergeManager'
            });
          } else{
            console.error('> uh oh: no valid accessToken')
            App.toast('Authorization denied','error');
            App.store.dispatch('user/logout');
            App.router.replace({
              name: 'login'
            });
          }
        }).catch(function(e){
          console.error('> blah', e);
          App.toast('Authorization denied','error');
          App.store.dispatch('user/logout');
          App.router.replace({
            name: 'login'
          });
        }).then(function(){
          App.evt.emit(App.actions.LOADING, false);
        });
      });
    }
  });

})();
Vue.component('auth-callback',AuthCallback);
var LoginPage = (function(){

  return new BaseRoute({
    template:'#login-page',
    methods: {
      goto: function(){
        App.evt.emit(App.actions.LOADING, true);
        App.router.replace({
          name: 'conciergeManager'
        });
      }
    }
  });

})();
Vue.component('login-page',LoginPage);
var ContentManager = (function(){

  return new AuthenticatedRoute({
    template:'#content-manager',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.loadFrame();
      })
    },
    beforeRouteLeave: function(to, from, next){
      window.removeEventListener('message', this.loadHandlerFn);
      next();
    },
    data: function(){
      return {
        loadHandlerFn: null
      }
    },
    computed: {
      injectPayload: function(){
        return {
          env: App.store.getters['config/envStr'],
          host: App.store.state.config.HOST,
          token: Flybits.Session.userToken
        };
      }
    },
    methods: {
      loadFrame: function(){
        var vm = this;
        var frame = this.$refs.frame;

        this.loadHandlerFn = function(evt){
          if(evt?.data?.type === 'flb.contentmanager.ready'){
            console.log('> flb.contentmanager.ready');
            vm.inject();
          }
        }
        window.addEventListener('message', this.loadHandlerFn);
        frame.setAttribute('src',App.store.state.config.CONTENTMANAGER);
      },
      inject: function(){
        var frame = this.$refs.frame;
        frame.contentWindow.postMessage(this.injectPayload, App.store.state.config.CONTENTMANAGER);
      },
    }
  });

})();
Vue.component('content-manager',ContentManager);
var ConfigStore = (function(){
  var deferredInit = new Deferred();

  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      HOST: 'https://api.demo.flybits.com',
      res: {},
      debug: false
    },
    getters: {
      envStr: function(state, getters){
        return state.HOST.split('.')[1];
      }
    },
    mutations: {
      setDefaults: function(state, json){
        state.HOST = json.HOST;
        state.APPHOST = json.APPHOST;
        state.PROJECTID = json.PROJECTID;
        state.PIXELHOST = json.PIXELHOST;
        state.CLIENTID = json.CLIENTID;
        state.CONTENTMANAGER = 'https://experiences.flybits.app/#/manage/content';
        state.JOURNEYMANAGER = 'https://experiences.flybits.app/#/journey/templates/manage';
        state.COMPONENTMANAGER = 'https://experiences.flybits.app/#/component/templates/manage';
        state.res = json.res;
        state.store = json.store;
        state.debug = json.debug;
        state.namespace = json.namespace;
      },
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      }
    },
    actions: {
      parse: function(context){
        var def = new Deferred();

        fetch(App.ext.CONFIG).then(function(resp){
          if(resp.status !== 200){
            throw new Validation().addError("Configuration file not found","Reverting to default configuration. No configuration found at:"+app.ext.CONFIG,{
              code: Flybits.Validation.type.MISSINGARG
            });
          }
          return resp.json();
        }).then(function(json){
          context.commit('setDefaults', json.defaults);
          context.commit('setInitialized');
          def.resolve(json.defaults);
        }).catch(function(ex){
          if(ex instanceof Validation){
            def.reject(ex);
          } else{
            def.reject(new Validation().addError("Failed to read configuration file.","Reverting to default configuration. Configuration format incorrect at:"+app.ext.CONFIG,{
              code: Validation.type.MALFORMED
            }));
          }
        });

        return def.promise;
      }
    }
  };
})();
var UserStore = (function(){
  var deferredInit = new Deferred();
  const DBKeys = {
    USER: 'user'
  };

  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      isAdmin: false,
      user: null
    },
    mutations: {
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      },
      setUser: function(state, user){
        state.user = user;
        App.cache.setItem(DBKeys.USER, user.toJSON());
      },
      clearUser: function(state){
        state.isAdmin = false;
        App.cache.removeItem(DBKeys.USER);
      }
    },
    actions: {
      logout: function(context){
        context.commit('clearUser');
        Flybits.Session.disconnect();
      },
      resolveUser: function(context, bypassNetwork){
        var def = new Flybits.Deferred();
        var cachePromise = App.cache.getItem(DBKeys.USER);
        var sdkPromise = bypassNetwork?Promise.resolve():Flybits.api.User.getSignedInUser();
        
        Flybits.Deferred.settlePromises([cachePromise, sdkPromise]).then(function(results){
          if(results[0].status === 'resolved' && 
             results[1].status === 'resolved'){
            if(bypassNetwork && results[0].result){
              let user = new Flybits.User(results[0].result);
              context.commit('setUser', user);
              def.resolve(user);
            } else if(!bypassNetwork && results[1].result){
              let user = results[1].result;
              context.commit('setUser', user);
              def.resolve(user);
            } else{
              def.reject(new Flybits.Validation().addError('No valid session', '', {
                type: Flybits.Validation.type.NOTFOUND
              }));
            }
          } else{
            def.reject(new Flybits.Validation().addError('No valid session', '', {
              type: Flybits.Validation.type.NOTFOUND
            }));
          }
        }).catch(function(e){
          def.reject(new Flybits.Validation().addError('No valid session', '', {
            type: Flybits.Validation.type.NOTFOUND
          }));
        });

        return def.promise;
      }
    }
  };
})();
var ZoneStore = (function(){
  var deferredInit = new Deferred();

  var API = {
    getObject: function(){
      return Flybits.api.Zones.getAll();
    },
    saveObject: function(zoneConfigs){
      return Flybits.api.Zones.saveObject(zoneConfigs);
    }
  };
  
  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      zones: [],
      zoneConfigs: null
    },
    getters: {
      modules: function(state, getters){
        var retArr = [];
        state.zones.forEach(function(zone){
          Array.prototype.push.apply(retArr, zone.modules);
        });
        return retArr;
      }
    },
    mutations: {
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      },
      setConfig: function(state, config){
        state.zoneConfigs = config;
        state.zones = config?config.zones:[];
      }
    },
    actions: {
      hydrate: function(context){
        var def = new Deferred();
        
        API.getObject().then(function(obj){
          context.commit('setConfig', obj);
          if(!context.state.initialized){
            context.commit('setInitialized');
          }
          def.resolve();
        }).catch(function(e){
          if(e.firstError().serverCode === 404){
            context.state.zoneConfigs = new Flybits.ZoneConfigs();
            context.state.zones = context.state.zoneConfigs.zones;
            if(!context.state.initialized){
              context.commit('setInitialized');
            } 

            def.resolve();
          } else{
            def.reject(e);
          }
        });

        return def.promise;
      },
      saveAll: function(context){
        var def = new Flybits.Deferred();
        API.saveObject(context.state.zoneConfigs).then(function(zoneConfigs){
          context.commit('setConfig', zoneConfigs);
          def.resolve();
        }).catch(function(e){
          def.reject(e);
        });

        return def.promise;
      }
    }
  }
})();
var ContentStore = (function(){
  var deferredInit = new Deferred();

  const TEMPLATEDISPLAYMAP = {
    'special-events': {
      carousel: ['carousel'],
      lander: ['lander'],
      details: ['details']
    },
    'special-offers': {
      carousel: ['carousel'],
      lander: ['lander'],
      details: ['details']
    },
    'education': {
      carousel: ['carousel'],
      lander: ['lander'],
      details: ['details']
    },
    'personalized-info': {
      carousel: ['carousel'],
      lander: ['lander'],
      details: ['details']
    },
    'td-for-me': {
      carousel: ['carousel'],
      lander: ['lander'],
      details: ['details']
    },
    'alert-card': {
      alert: ['icon','description','textlink']
    },
    'dynamic-page': {
      details: ['banner','header','options']
    },
    'input-page': {
      details: ['banner','primaryMsg','secondaryMsg','actionLink','secondaryLinks']
    }
  }

  var API = {
    getContent: function(id){
      var def = new Deferred();
      var url = Flybits.cfg.HOST + Flybits.cfg.res.CONTENTS + 
                '/' + id;
      var query = {
        data: true,
        limit: 2000,
        managementMode: true,
        returnRichText: true,
        disableContextEmbed: true
      };

      query = Flybits.util.Api.toURLParams(query);
      if(query !== ''){
        url += '?' + query;
      }

      Flybits.util.Api.flbFetch(url, {
        method: 'GET'
      }).then(function(res){
        def.resolve(new Content(res.body));
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getContents: function(opts){
      opts = opts || {};
      var def = new Deferred();
      var url = Flybits.cfg.HOST + Flybits.cfg.res.CONTENTS;
      var query = {
        data: true,
        limit: 2000,
        managementMode: true,
        returnRichText: true,
        disableContextEmbed: true
      };
      if(opts.labels && opts.labels.length){
        query.labelsFormula = '('+opts.labels.join(';')+')'
      }
      if(opts.ids && Array.isArray(opts.ids)){
        query.contentIds = opts.ids.join(',');
      }      

      query = Flybits.util.Api.toURLParams(query);
      if(query !== ''){
        url += '?' + query;
      }

      Flybits.util.Api.flbFetch(url, {
        method: 'GET'
      }).then(function(res){
        def.resolve(res.body.data);
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    saveInstance: function(obj){
      var def = new Deferred();
      var url = Flybits.cfg.HOST + Flybits.cfg.res.CONTENTS
                + '/' + obj.id;

      Flybits.util.Api.flbFetch(url, {
        method: 'PUT',
        body: JSON.stringify(obj)
      }).then(function(res){
        def.resolve();
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    saveData: function(obj, instanceID, dataID){
      var def = new Deferred();
      var url = Flybits.cfg.HOST + Flybits.cfg.res.CONTENTS
                + '/' + instanceID + '/data/' + dataID;

      Flybits.util.Api.flbFetch(url, {
        method: 'PUT',
        body: JSON.stringify(obj)
      }).then(function(res){
        def.resolve();
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getAllTemplates: function(){
      return Flybits.api.ContentTemplate.getAll({
        paging: {
          limit: 200
        }
      });
    }
  }

  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      content: [],
      templates: []
    },
    getters: {
      getTemplateByID: function(state){
        return function(id){
          return state.templates.filter(function(t){
            return t.id === id;
          })[0];
        };
      },
      getContentByLabels: function(state){
        return function(labels){
          return state.content.filter(function(c){
            return App.util.Obj.intersection(c.labels, labels).length > 0;
          });
        }
      },
      getTemplateAttrMapping: function(state, getters){
        return function(id){
          return getters.getTemplateByID(id)?TEMPLATEDISPLAYMAP[getters.getTemplateByID(id).type]:null;
        }
      }
    },
    mutations: {
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      },
      addContent: function(state, content){
        var exists = state.content.filter(function(c){
          return c.id === content.id;
        })[0];
        if(!exists){
          state.content.push(content);
        }
      },
      setContent: function(state, contentArr){
        state.content = contentArr.map(function(c){
          return new Content(c);
        });
      },
      addTemplate: function(state, template){
        var exists = state.templates.filter(function(t){
          return t.id === template.id;
        })[0];
        if(!exists){
          state.templates.push(template);
        }
      },
      setTemplates: function(state, templateArr){
        state.templates = templateArr;
      },
      removeContent: function(state, content){
        App.util.Obj.removeObject(state.content, content);
      }
    },
    actions: {
      getByID: function(context, id){
        var fetchPromise = API.getContent(id);
        fetchPromise.then(function(content){
          context.commit('addContent', content);
        });

        return fetchPromise;
      },
      getByIDs: function(context, opts){
        if(!opts || !opts.ids.length){
          return Promise.resolve([]);
        }
        var fetchPromise = API.getContents(opts);
        fetchPromise.then(function(contentInstances){
          context.commit('addContent', contentInstances);
        });

        return fetchPromise;
      },
      getTemplateByID: function(context, id){
        var fetchPromise = Flybits.api.ContentTemplate.get(id);
        fetchPromise.then(function(template){
          context.commit('addTemplate', template);
        });

        return fetchPromise;
      },
      hydrate: function(context){
        var def = new Deferred();
        var promises = [
          API.getAllTemplates(),  
          API.getContents()
        ];

        Deferred.settlePromises(promises).then(function(response){
          if(response[0].status === 'rejected'){
            App.toast('Failed to load Content Templates');
            console.error(response[0].result);
          } else{
            context.commit('setTemplates', response[0].result.result);
          }
          if(response[1].status === 'rejected'){
            App.toast('Failed to load Content');
            console.error(response[1].result);
            def.reject();
          } else{
            context.commit('setContent', response[1].result);
            def.resolve();
          }

          if(!context.state.initialized){
            context.commit('setInitialized');
          }
        });

        return def.promise;
      },
      delete: function(context, content){
        context.commit('removeContent', content);
        var def = new Deferred();
        Flybits.api.Content.delete(content).then(function(){
          def.resolve();
        }).catch(function(e){
          context.commit('addContent', content);
          def.reject(e);
        });

        return def.promise;
      }
    }
  };
})();
var ComponentStore = (function(){
  return {
    namespaced: true,
    state: {
      uiTemplates: [
        {
          key: 'special-events',
          defaultUI: {
            html: `
              <div class="card-base card-info special-event" dmb="dmb" dmb:type="blk" v-on:click="emitAction('details://?title='+data.categoryName,{type:'card',name:'card',compID:'card'})" role="button" tabindex="0">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']">
                  <div class="category-icon" v-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon">
                  </div>
                </div>
                <div class="main-body" v-if="data" dmb="dmb" dmb:type="blk">
                  <div class="date-blk" v-if="data.startDateTime" dmb="dmb" dmb:type="date">
                    <div class="month" dmb="dmb">
                      <datetime-field v-bind:datetime="data.startDateTime" format="aMMM"></datetime-field>
                    </div>
                    <div class="date" dmb="dmb">
                      <datetime-field v-bind:datetime="data.startDateTime" format="DD"></datetime-field>
                    </div>
                  </div>
                  <div class="meta-blk" dmb="dmb" dmb:type="blk" dmb:style="max-height:none;-webkit-line-clamp:initial;">
                    <div class="carousel title dmb-text" v-if="data.carousel && data.carousel.title" dmb="dmb" dmb:type="text">{{data.carousel.title}}</div dmb="dmb">
                    <div class="lander title dmb-text" v-if="data.lander && data.lander.title" dmb="dmb" dmb:type="text">{{data.lander.title}}</div dmb="dmb">
                    <br/>
                    <div class="carousel description dmb-textarea" v-if="data.carousel && data.carousel.description" v-rtf="data.carousel.description" dmb="dmb" dmb:type="textarea"></div>
                    <div class="lander description dmb-textarea" v-if="data.lander && data.lander.description" v-rtf="data.lander.description" dmb="dmb" dmb:type="textarea"></div>
                  </div>
                  <div class="details-link" dmb="dmb" dmb:type="icon" aria-hidden="true">›</div>
                </div>
              </div>
            `,
            css: /*css*/`
              .card-info.card-base {
                margin: 0;
                position: relative;
                width: 100%;
                margin: 0;
                border-radius: 8px;
                overflow: hidden;
                background-color: white;
                border: none;
                box-shadow: 0px 1px 4px 0px rgba(28, 28, 28, 0.03),
                            0px 1px 8px 0px rgba(28, 28, 28, 0.06);
                color: #1c1c1c;
                cursor: pointer;
              }

              .card-info::after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }
              
              .card-info .img-blk {
                position: relative;
                height: 130px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-bottom: 1px solid #CCCCCC;
              }
              
              .card-info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 40px;
                height: 40px;
                position: absolute;
                transform: translateY(-50%);
                top: 130px;
                right: 16px;
                z-index: 1;
              }
              
              .card-info .main-body {
                padding: 16px;
                padding-right: 41px;
                position: relative;
              }

              .android .card-info .main-body{
                padding-right: 16px;
              }
              
              .card-info:active .main-body {
                background-color: whitesmoke;
              }
              
              .card-info.special-event .main-body .date-blk {
                display: none;
              }
              
              .card-info.special-event .main-body .date-blk {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                text-align: center;
                color: #295A61;
              }
              
              .card-info.special-event .main-body .date-blk .month {
                font-size: 12px;
              }
              
              .card-info.special-event .main-body .date-blk .date {
                font-size: 19px;
              }
              
              .card-info.special-event .main-body .meta-blk {
                max-height: 57px;
                height: 57px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                line-height: 19px;
                font-size: 16px;
                letter-spacing: -0.43px;
              }
              
              .card-info.special-event .main-body .title {
                font-weight: bold;
                display: inline;
              }
              .card-info.special-event .main-body .title.lander{
                display: none;
              }
              
              .card-info.special-event .main-body .description {
                position: relative;
                max-height: 38px;
                height: 38px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              .card-info.special-event .main-body .description.lander{
                display: none;
              }

              .card-info.special-event .main-body p {
                margin: 0;
              }
              
              .card-info.special-event .main-body .details-link {
                position: absolute;
                right: 16px;
                bottom: 50%;
                transform: translateY(50%);
                font-size: 27px;
                cursor: pointer;
                color: #767676;
              }

              .android .card-info.special-event .main-body .details-link {
                display: none;
              }
              
              .flb-layout.info-group .card-info{
                box-shadow: none;
                border-radius: 0;
              }

              .flb-layout.info-group .card-info.special-event .main-body .date-blk {
                display: block;
              }
              
              .flb-layout.info-group .card-info.special-event .main-body .meta-blk {
                padding-left: 39px;
                max-height: 76px;
                height: auto;
                -webkit-line-clamp: 4;
              }
              
              .flb-layout.info-group .card-info.special-event .main-body .title.carousel{
                display: none;
              }
              .flb-layout.info-group .card-info.special-event .main-body .title.lander{
                display: inline;
              }
              
              .flb-layout.info-group .card-info.special-event .main-body .description.carousel {
                display: none;
              }
              .flb-layout.info-group .card-info.special-event .main-body .description.lander{
                max-height: 57px;
                height: auto;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            `
          },
          detailsUI: {
            html: `
              <div class="details-page info" dmb="dmb" dmb:type="blk" v-track-custom-data="{content:{title:'details.title',category:'categoryName',location:'$moduleName'}}">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']">
                  <div class="category-icon" v-if="data && data.details.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.details.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                  <div class="category-icon" v-else-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                </div>
                <div class="main-content" dmb="dmb" dmb:type="blk">
                  <div class="title" dmb="dmb" dmb:type="text" v-if="data.details" role="heading" aria-level="1">{{data.details.title}}</div>
                  <div class="meta-wrap" dmb="dmb" dmb:type="blk">
                    <div class="meta-item date" v-if="data.startDateTime" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-if="data.details" v-bind:style="{backgroundImage: 'url('+data.details.dateIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Date."></div> 
                      <div><span class="meta-value" dmb="dmb" dmb:type="text" dmb:size="10">
                        <datetime-field v-bind:datetime="data.startDateTime" format="aMMM DD"></datetime-field>
                      </span><span v-if="data.endDateTime && !(new Date(data.startDateTime).getDate() === new Date(data.endDateTime).getDate() && new Date(data.startDateTime).getMonth() === new Date(data.endDateTime).getMonth())" aria-label="to"> - </span><span class="meta-value" v-if="data.endDateTime && !(new Date(data.startDateTime).getDate() === new Date(data.endDateTime).getDate() && new Date(data.startDateTime).getMonth() === new Date(data.endDateTime).getMonth())" dmb="dmb" dmb:type="text" dmb:size="10">
                        <datetime-field v-bind:datetime="data.endDateTime" format="aMMM DD"></datetime-field>
                      </span></div>
                    </div>
                    <div class="meta-item time" v-if="data.startDateTime" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div dmb="dmb" dmb:type="img" v-if="data.details" v-bind:style="{backgroundImage: 'url('+data.details.timeIcon+')'}" class="meta-icon" aria-label="Time."></div>
                      <div><span class="meta-value" v-if="data.startDateTime" dmb="dmb" dmb:type="text" dmb:size="10">
                        <datetime-field v-bind:datetime="data.startDateTime" format="HH:mm" clockType="12"></datetime-field>
                      </span><span v-if="data.endDateTime" aria-label="to"> - </span><span class="meta-value" v-if="data.endDateTime" dmb="dmb" dmb:type="text" dmb:size="10">
                        <datetime-field v-bind:datetime="data.endDateTime" format="HH:mm" clockType="12"></datetime-field>
                      </span></div>
                    </div>
                    <div class="meta-item location" v-if="data.details && data.details.location" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div dmb="dmb" dmb:type="img" v-bind:style="{backgroundImage: 'url('+data.details.locationIcon+')'}" class="meta-icon" aria-label="Location."></div>
                      <div><span class="meta-value" dmb="dmb" dmb:type="text" dmb:size="10">{{data.details.location}}</span></div>
                    </div>
                  </div>
                  <div class="body-text body-wrap" v-if="data.details && data.details.body" v-rtf="data.details.body" dmb="dmb" dmb:type="textarea"></div>
                  <div class="body-text legal-wrap" v-rtf="data.details.legalCopy" v-if="data.details && data.details.legalCopy" dmb="dmb" dmb:type="textarea"></div>
                </div>
                <div class="con-wrap" v-if="data.details && data.details.buttons && data.details.buttons.length" dmb="dmb" dmb-spacer:style="width:100%;" dmb:type="blk">
                  <div class="button" v-bind:item-index="index" v-for="(button,index) in data.details.buttons" dmb="dmb" v-on:click.stop.prevent="emitAction(button.uri,{type:'button',name:button.label,compID:'btn'+index})" role="button">
                    <div class="inner-btn" dmb="dmb" dmb:type="text">{{button.label}}</div>
                  </div>
                </div>
              </div>
            `,
            css: /*css*/`
              .details-page.info{
                position: relative;
                background-color: #F3F3F3;
              }
              .details-page.info .img-blk {
                position: relative;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                height: 180px;
                border-bottom: 1px solid #cccccc;
              }
            
              .details-page.info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 50px;
                height: 50px;
                position: absolute;
                transform: translateY(-50%);
                top: 180px;
                right: 20px;
              }
            
              .details-page.info .main-content {
                padding: 45px 16px 0px 16px;
                color: #1c1c1c;
                background-color: white;
              }
            
              .details-page.info .main-content .title {
                font-size: 21px;
                line-height: 25px;
                font-weight: 500;
                letter-spacing: -0.43px;
              }
            
              .details-page.info .main-content .meta-wrap {
                font-size: 16px;
                color: #555555;
                margin-top: 20px;
                letter-spacing: -0.43px;
              }
            
              .details-page.info .main-content .meta-wrap .meta-item {
                margin-bottom: 10px;
                display: grid;
                grid-template-columns: 30px auto;
              }
            
              .details-page.info .main-content .meta-wrap .meta-item span,
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                vertical-align: middle
              }
            
              .details-page.info .main-content .meta-wrap .meta-item:last-of-type {
                margin-bottom: 0;
              }
            
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                position: relative;
                width: 20px;
                height: 20px;
                margin-right: 10px;
                display: inline-block;
                background-size: cover;
                background-position: center;
                vertical-align: middle;
              }
            
              .details-page.info .main-content .meta-wrap .meta-item .meta-value {
                display: inline-block;
                line-height: 20px;
                font-size: 16px;
                vertical-align: middle;
              }
            
              .details-page.info .main-content .body-text {
                padding-top: 20px;
                font-size: 16px;
                line-height: 22px;
                color: black;
                letter-spacing: -0.43px;
              }
            
              .details-page.info .main-content .body-wrap {
                border-top: 1px solid #cccccc;
                margin-top: 20px;
                overflow: hidden;
              }
            
              .con-wrap {
                position: relative;
                background-color: white;
                padding: 20px 16px;
              }

              .con-wrap .button {
                text-align: center;
                border: 1px solid #008a00;
                color: #008a00;
                font-size: 17px;
                letter-spacing: -0.43px;
                padding: 12px 0;
                margin-bottom: 16px;
                cursor: pointer;
              }

              .android .con-wrap .button{
                margin: 8px;
              }
            
              .con-wrap .button:first-of-type {
                background-color: #008a00;
                color: white;
                font-weight: bold;
              }
              .con-wrap .button:last-of-type {
                margin-bottom: 0;
              }
            
              .con-wrap .button:active {
                background-color: #1A5336;
                color: white;
                border: 1px solid #1A5336;
              }

              @media (min-width: 710px) {
                .details-page.info{
                  padding: 32px 64px;
                }
                .con-wrap {
                  padding: 12.5px 64px;
                }
                .con-wrap .button{
                  max-width: 330px;
                }
              }
              @media (min-width: 810px) {
                .details-page.info .img-blk {
                  height: 300px;
                }
                .details-page.info .category-icon {
                  right: 70px;
                  top: 300px;
                }
                .details-page.info .main-content {
                  padding: 45px 70px 120px 70px;
                }
              }
            `
          }
        },
        {
          key: 'special-offers',
          defaultUI: {
            html: `
              <div class="card-base card-info special-offer" dmb="dmb" dmb:type="blk" v-on:click="emitAction('details://?title='+data.categoryName,{type:'card',name:'card',compID:'card'})" role="button" tabindex="0">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']"></div>
                <div class="category-icon" v-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                <div class="main-body" v-if="data" dmb="dmb" dmb:type="blk">
                  <div class="meta-blk" dmb="dmb" dmb:type="blk" dmb:style="max-height:none;-webkit-line-clamp:initial;">
                    <div class="carousel title dmb-text" v-if="data.carousel && data.carousel.title" dmb="dmb" dmb:type="text">{{data.carousel.title}}</div dmb="dmb">
                    <div class="lander title dmb-text" v-if="data.lander && data.lander.title" dmb="dmb" dmb:type="text">{{data.lander.title}}</div dmb="dmb">
                    <br/>
                    <div class="carousel description dmb-textarea" v-if="data.carousel && data.carousel.description" v-rtf="data.carousel.description" dmb="dmb" dmb:type="textarea"></div>
                    <div class="lander description dmb-textarea" v-if="data.lander && data.lander.description" v-rtf="data.lander.description" dmb="dmb" dmb:type="textarea"></div>
                  </div>
                  <div class="details-link" dmb="dmb" dmb:type="icon" aria-hidden="true">›</div>
                </div>
              </div>
            `,
            css: /*css*/`
              .card-info.card-base {
                margin: 0;
                position: relative;
                width: 100%;
                margin: 0;
                border-radius: 8px;
                overflow: hidden;
                background-color: white;
                border: none;
                box-shadow: 0px 1px 4px 0px rgba(28, 28, 28, 0.03),
                            0px 1px 8px 0px rgba(28, 28, 28, 0.06);
                color: #1c1c1c;
                cursor: pointer;
              }

              .card-info::after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }

              .card-info .img-blk {
                position: relative;
                height: 130px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-bottom: 1px solid #CCCCCC;
              }

              .card-info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 40px;
                height: 40px;
                position: absolute;
                transform: translateY(-50%);
                top: 130px;
                right: 16px;
                z-index: 1;
              }

              .card-info .main-body {
                padding: 16px;
                padding-right: 41px;
                position: relative;
              }
              
              .android .card-info .main-body{
                padding-right: 16px;
              }

              .card-info:active .main-body{
                background-color: whitesmoke;
              }

              .card-info .main-body .meta-blk {
                max-height: 57px;
                height: 57px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                line-height: 19px;
                font-size: 16px;
                letter-spacing: -0.43px;
              }

              .card-info .main-body .title {
                font-weight: bold;
                display: inline;
              }

              .card-info .main-body .title.lander{
                display: none;
              }

              .card-info .main-body .description {
                position: relative;
                max-height: 38px;
                height: 38px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .card-info .main-body .description.lander{
                display: none;
              }

              .card-info .main-body p {
                margin: 0;
              }

              .card-info .main-body .details-link {
                position: absolute;
                right: 16px;
                bottom: 50%;
                transform: translateY(50%);
                font-size: 27px;
                color: #767676;
              }

              .android .card-info .main-body .details-link {
                display: none;
              }

              .flb-layout.info-group .card-info {
                box-shadow: none;
                border-radius: 0;
              }

              .flb-layout.info-group .card-info .main-body .meta-blk {
                max-height: 80px;
                height: auto;
                -webkit-line-clamp: 4;
              }

              .flb-layout.info-group .card-info .main-body .title.carousel{
                display: none;
              }
              .flb-layout.info-group .card-info .main-body .title.lander{
                display: inline;
              }
              
              .flb-layout.info-group .card-info .main-body .description.carousel {
                display: none;
              }
              .flb-layout.info-group .card-info .main-body .description.lander{
                max-height: 57px;
                height: auto;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            `
          },
          detailsUI: {
            html: `
              <div class="details-page info" dmb="dmb" dmb:type="blk" v-track-custom-data="{content:{title:'details.title',category:'categoryName',location:'$moduleName'}}">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']">
                  <div class="category-icon" v-if="data && data.details.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.details.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                  <div class="category-icon" v-else-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                </div>
                <div class="main-content" dmb="dmb" dmb:type="blk">
                  <div class="title" dmb="dmb" dmb:type="text" v-if="data.details" role="heading" aria-level="1">{{data.details.title}}</div>
                  <div class="meta-wrap" dmb="dmb" dmb:type="blk">
                    <div class="meta-item date" v-if="data.details && data.details.startDate" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.dateIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Start Date."></div>
                      <div><span class="meta-value" dmb="dmb" dmb:type="text" dmb:size="10">{{data.details.startDate}}</span></div>
                    </div>
                    <div class="meta-item date" v-if="data.details && data.details.endDate" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.dateIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="End Date."></div>
                      <div><span class="meta-value" dmb="dmb" dmb:type="text" dmb:size="10">{{data.details.endDate}}</span></div>
                    </div>
                    <div class="meta-item location" v-if="data.details && data.details.location" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.locationIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Location."></div> <span class="meta-value" dmb="dmb" dmb:type="text" dmb:size="10">{{data.details.location}}</span>
                    </div>
                  </div>
                  <div class="body-text body-wrap" v-if="data.details && data.details.body" v-rtf="data.details.body" dmb="dmb" dmb:type="textarea"></div>
                  <div class="body-text short opt-out" v-rtf="data.details.shortOptOut" v-if="data.details && data.details.shortOptOut" dmb="dmb" dmb:type="textarea"></div>
                  <div class="body-text legal-wrap" v-rtf="data.details.legalCopy" v-if="data.details && data.details.legalCopy" dmb="dmb" dmb:type="textarea"></div>
                  <div class="body-text long opt-out" v-rtf="data.details.longOptOut" v-if="data.details && data.details.longOptOut" dmb="dmb" dmb:type="textarea"></div>
                  <div class="body-text add legal-wrap" v-rtf="data.details.additionalLegalCopy" v-if="data.details && data.details.additionalLegalCopy" dmb="dmb" dmb:type="textarea"></div>
                </div>
                <div class="con-wrap" v-if="data.details && data.details.buttons && data.details.buttons.length" dmb="dmb" dmb-spacer:style="width:100%;" dmb:type="blk">
                  <div class="button" v-bind:item-index="index" v-for="(button,index) in data.details.buttons" dmb="dmb" v-on:click.stop.prevent="emitAction(button.uri,{type:'button',name:button.label,compID:'btn'+index})" role="button">
                    <div class="inner-btn" dmb="dmb" dmb:type="text">{{button.label}}</div>
                  </div>
                </div>
              </div>
            `,
            css: /*css*/`
              .details-page.info {
                position: relative;
                background-color: #F3F3F3;
              }
              .details-page.info .img-blk {
                position: relative;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                height: 180px;
                border-bottom: 1px solid #cccccc;
              }
              
              .details-page.info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 50px;
                height: 50px;
                position: absolute;
                transform: translateY(-50%);
                top: 180px;
                right: 20px;
              }
              
              .details-page.info .main-content {
                padding: 45px 16px 0px 16px;
                color: #1c1c1c;
                background-color: white;
              }
              
              .details-page.info .main-content .title {
                font-size: 21px;
                line-height: 25px;
                font-weight: 500;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .meta-wrap {
                font-size: 16px;
                color: #555555;
                margin-top: 20px;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item {
                margin-bottom: 10px;
                display: grid;
                grid-template-columns: 30px auto;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item span,
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                vertical-align: middle
              }
              
              .details-page.info .main-content .meta-wrap .meta-item:last-of-type {
                margin-bottom: 0;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                position: relative;
                width: 20px;
                height: 20px;
                display: inline-block;
                background-size: cover;
                background-position: center;
                vertical-align: middle;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item .meta-value {
                display: inline-block;
                line-height: 20px;
                font-size: 16px;
                vertical-align: middle;
              }
              
              .details-page.info .main-content .body-text {
                padding-top: 20px;
                font-size: 16px;
                line-height: 22px;
                color: black;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .body-text ul {
                padding-inline-start: 30px;
              }
              
              .details-page.info .main-content .body-wrap {
                border-top: 1px solid #cccccc;
                margin-top: 20px;
                overflow: hidden;
              }
              
              .details-page.info .main-content .short.opt-out {
                border: 1px solid #008A00;
                font-size: 17px;
                line-height: 22px;
                letter-spacing: -0.43px;
                margin-top: 20px;
                padding: 20px;
                color: black;
              }
              
              .details-page.info .main-content .legal-wrap {
                font-size: 13px;
                line-height: 15px;
                color: #555555;
              }
              
              .details-page.info .main-content .long.opt-out {
                border: 1px solid #008A00;
                font-size: 17px;
                line-height: 22px;
                margin-top: 20px;
                padding: 20px;
                color: black;
              }
              
              .con-wrap {
                position: relative;
                background-color: white;
                padding: 20px 16px;
              }

              .con-wrap .button {
                text-align: center;
                border: 1px solid #008a00;
                color: #008a00;
                font-size: 17px;
                letter-spacing: -0.43px;
                padding: 12px 0;
                margin-bottom: 16px;
                cursor: pointer;
              }

              .con-wrap .button:first-of-type {
                background-color: #008a00;
                color: white;
                font-weight: bold;
              }
              .con-wrap .button:last-of-type {
                margin-bottom: 0;
              }
              
              .con-wrap .button:active {
                background-color: #1A5336;
                color: white;
                border: 1px solid #1A5336;
              }

              @media (min-width: 710px) {
                .details-page.info{
                  padding: 32px 64px;
                }
                .con-wrap {
                  padding: 20px 64px;
                }
                .con-wrap .button{
                  max-width: 330px;
                }
              }
              @media (min-width: 810px) {
                .details-page.info .img-blk {
                  height: 300px;
                }
                .details-page.info .category-icon {
                  right: 70px;
                  top: 300px;
                }
                .details-page.info .main-content {
                  padding: 45px 70px 120px 70px;
                }
              }
            `
          }
        },
        {
          key: 'education',
          defaultUI: {
            html: `
              <div class="card-base card-info education" dmb="dmb" dmb:type="blk" v-on:click="emitAction('details://?title='+data.categoryName,{type:'card',name:'card',compID:'card'})" role="button" tabindex="0">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']"></div>
                <div class="category-icon" v-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                <div class="main-body" v-if="data" dmb="dmb" dmb:type="blk">
                  <div class="meta-blk" dmb="dmb" dmb:type="blk" dmb:style="max-height:none;-webkit-line-clamp:initial;">
                    <div class="carousel title dmb-text" v-if="data.carousel && data.carousel.title" dmb="dmb" dmb:type="text">{{data.carousel.title}}</div dmb="dmb">
                    <div class="lander title dmb-text" v-if="data.lander && data.lander.title" dmb="dmb" dmb:type="text">{{data.lander.title}}</div dmb="dmb">
                    <br/>
                    <div class="carousel description dmb-textarea" v-if="data.carousel && data.carousel.description" v-rtf="data.carousel.description" dmb="dmb" dmb:type="textarea"></div>
                    <div class="lander description dmb-textarea" v-if="data.lander && data.lander.description" v-rtf="data.lander.description" dmb="dmb" dmb:type="textarea"></div>
                  </div>
                  <div class="details-link" dmb="dmb" dmb:type="icon" aria-hidden="true">›</div>
                </div>
              </div>
            `,
            css: /*css*/`
              .card-info.card-base {
                margin: 0;
                position: relative;
                width: 100%;
                margin: 0;
                border-radius: 8px;
                overflow: hidden;
                background-color: white;
                border: none;
                box-shadow: 0px 1px 4px 0px rgba(28, 28, 28, 0.03),
                            0px 1px 8px 0px rgba(28, 28, 28, 0.06);
                color: #1c1c1c;
                cursor: pointer;
              }

              .card-info::after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }

              .card-info .img-blk {
                position: relative;
                height: 130px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-bottom: 1px solid #CCCCCC;
              }

              .card-info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 40px;
                height: 40px;
                position: absolute;
                transform: translateY(-50%);
                top: 130px;
                right: 16px;
                z-index: 1;
              }

              .card-info .main-body {
                padding: 16px;
                padding-right: 41px;
                position: relative;
              }

              .android .card-info .main-body{
                padding-right: 16px;
              }

              .card-info:active .main-body{
                background-color: whitesmoke;
              }

              .card-info .main-body .meta-blk {
                max-height: 57px;
                height: 57px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                line-height: 19px;
                font-size: 16px;
                letter-spacing: -0.43px;
              }

              .card-info .main-body .title {
                font-weight: bold;
                display: inline;
              }

              .card-info .main-body .title.lander{
                display: none;
              }

              .card-info .main-body .description {
                position: relative;
                max-height: 38px;
                height: 38px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .card-info .main-body .description.lander{
                display: none;
              }

              .card-info .main-body p {
                margin: 0;
              }

              .card-info .main-body .details-link {
                position: absolute;
                right: 16px;
                bottom: 50%;
                transform: translateY(50%);
                font-size: 27px;
                color: #767676;
              }

              .android .card-info .main-body .details-link {
                display: none;
              }

              .flb-layout.info-group .card-info {
                box-shadow: none;
                border-radius: 0;
              }

              .flb-layout.info-group .card-info .main-body .meta-blk {
                max-height: 80px;
                height: auto;
                -webkit-line-clamp: 4;
              }

              .flb-layout.info-group .card-info .main-body .title.carousel{
                display: none;
              }
              .flb-layout.info-group .card-info .main-body .title.lander{
                display: inline;
              }
              
              .flb-layout.info-group .card-info .main-body .description.carousel {
                display: none;
              }
              .flb-layout.info-group .card-info .main-body .description.lander{
                max-height: 57px;
                height: auto;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            `
          },
          detailsUI: {
            html: `
              <div class="details-page info" dmb="dmb" dmb:type="blk" v-track-custom-data="{content:{title:'details.title',category:'categoryName',location:'$moduleName'}}">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']">
                  <div class="category-icon" v-if="data && data.details.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.details.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                  <div class="category-icon" v-else-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                </div>
                <div class="main-content" dmb="dmb" dmb:type="blk">
                  <div class="title" dmb="dmb" dmb:type="text" v-if="data.details" role="heading" aria-level="1">{{data.details.title}}</div>
                  <div class="meta-wrap"  dmb="dmb" dmb:type="blk">
                    <div class="meta-item date" v-if="data.details && data.details.startDate" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.dateIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Date."></div>
                      <div><span class="meta-value" dmb="dmb" dmb:type="text" dmb:size="10">{{data.details.startDate}}</span></div>
                    </div>
                    <div class="meta-item location" v-if="data.details && data.details.location" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.locationIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Location."></div> 
                      <div><span class="meta-value" dmb="dmb" dmb:type="text" dmb:size="10">{{data.details.location}}</span></div>
                    </div>
                  </div>
                  <div class="body-text body-wrap" v-if="data.details && data.details.body" v-rtf="data.details.body" dmb="dmb" dmb:type="textarea"></div>
                  <div class="body-text legal-wrap" v-rtf="data.details.legalCopy" v-if="data.details && data.details.legalCopy" dmb="dmb" dmb:type="textarea"></div>
                </div>
                <div class="con-wrap" v-if="data.details && data.details.buttons && data.details.buttons.length" dmb="dmb" dmb-spacer:style="width:100%;" dmb:type="blk">
                  <div class="button" v-bind:item-index="index" v-for="(button,index) in data.details.buttons" dmb="dmb" v-on:click.stop.prevent="emitAction(button.uri,{type:'button',name:button.label,compID:'btn'+index})" role="button">
                    <div class="inner-btn" dmb="dmb" dmb:type="text">{{button.label}}</div>
                  </div>
                </div>
              </div>
            `,
            css: /*css*/`
              .details-page.info {
                position: relative;
                background-color: #F3F3F3;
              }
              .details-page.info .img-blk {
                position: relative;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                height: 180px;
                border-bottom: 1px solid #cccccc;
              }
              
              .details-page.info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 50px;
                height: 50px;
                position: absolute;
                transform: translateY(-50%);
                top: 180px;
                right: 20px;
              }
              
              .details-page.info .main-content {
                padding: 45px 16px 0px 16px;
                color: #1c1c1c;
                background-color: white;
              }
              
              .details-page.info .main-content .title {
                font-size: 21px;
                line-height: 25px;
                font-weight: 500;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .meta-wrap {
                font-size: 16px;
                color: #555555;
                margin-top: 20px;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item {
                margin-bottom: 10px;
                display: grid;
                grid-template-columns: 30px auto;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item span,
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                vertical-align: middle
              }
              
              .details-page.info .main-content .meta-wrap .meta-item:last-of-type {
                margin-bottom: 0;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                position: relative;
                width: 20px;
                height: 20px;
                display: inline-block;
                background-size: cover;
                background-position: center;
                vertical-align: middle;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item .meta-value {
                display: inline-block;
                line-height: 20px;
                font-size: 16px;
                vertical-align: middle;
              }
              
              .details-page.info .main-content .body-text {
                padding-top: 20px;
                font-size: 16px;
                line-height: 22px;
                color: black;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .body-text ul {
                padding-inline-start: 30px;
              }
              
              .details-page.info .main-content .body-wrap {
                border-top: 1px solid #cccccc;
                margin-top: 20px;
                overflow: hidden;
              }
              
              .con-wrap {
                position: relative;
                background-color: white;
                padding: 20px 16px;
              }

              .con-wrap .button {
                text-align: center;
                border: 1px solid #008a00;
                color: #008a00;
                font-size: 17px;
                letter-spacing: -0.43px;
                padding: 12px 0;
                margin-bottom: 16px;
                cursor: pointer;
              }

              .con-wrap .button:first-of-type {
                background-color: #008a00;
                color: white;
                font-weight: bold;
              }
              .con-wrap .button:last-of-type {
                margin-bottom: 0;
              }
              
              .con-wrap .button:active {
                background-color: #1A5336;
                color: white;
                border: 1px solid #1A5336;
              }
              
              @media (min-width: 710px) {
                .details-page.info{
                  padding: 32px 64px;
                }
                .con-wrap {
                  padding: 12.5px 64px;
                }
                .con-wrap .button{
                  max-width: 330px;
                }
              }
              @media (min-width: 810px) {
                .details-page.info .img-blk {
                  height: 300px;
                }
                .details-page.info .category-icon {
                  right: 70px;
                  top: 300px;
                }
                .details-page.info .main-content {
                  padding: 45px 70px 120px 70px;
                }
              }
            `
          }
        },
        {
          key: 'personalized-info',
          defaultUI: {
            html: `
              <div class="card-base card-info education" dmb="dmb" dmb:type="blk" v-on:click="emitAction('details://?title='+data.categoryName,{type:'card',name:'card',compID:'card'})" role="button" tabindex="0">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']"></div>
                <div class="category-icon" v-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                <div class="main-body" v-if="data" dmb="dmb" dmb:type="blk">
                  <div class="meta-blk" dmb="dmb" dmb:type="blk" dmb:style="max-height:none;-webkit-line-clamp:initial;">
                    <div class="carousel title dmb-text" v-if="data.carousel && data.carousel.title" dmb="dmb" dmb:type="text">{{data.carousel.title}}</div dmb="dmb">
                    <div class="lander title dmb-text" v-if="data.lander && data.lander.title" dmb="dmb" dmb:type="text">{{data.lander.title}}</div dmb="dmb">
                    <br/>
                    <div class="carousel description dmb-textarea" v-if="data.carousel && data.carousel.description" v-rtf="data.carousel.description" dmb="dmb" dmb:type="textarea"></div>
                    <div class="lander description dmb-textarea" v-if="data.lander && data.lander.description" v-rtf="data.lander.description" dmb="dmb" dmb:type="textarea"></div>
                  </div>
                  <div class="details-link" dmb="dmb" dmb:type="icon" aria-hidden="true">›</div>
                </div>
              </div>
            `,
            css: /*css*/`
              .card-info.card-base {
                margin: 0;
                position: relative;
                width: 100%;
                margin: 0;
                border-radius: 8px;
                overflow: hidden;
                background-color: white;
                border: none;
                box-shadow: 0px 1px 4px 0px rgba(28, 28, 28, 0.03),
                            0px 1px 8px 0px rgba(28, 28, 28, 0.06);
                color: #1c1c1c;
                cursor: pointer;
              }

              .card-info::after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }

              .card-info .img-blk {
                position: relative;
                height: 130px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-bottom: 1px solid #CCCCCC;
              }

              .card-info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 40px;
                height: 40px;
                position: absolute;
                transform: translateY(-50%);
                top: 130px;
                right: 16px;
                z-index: 1;
              }

              .card-info .main-body {
                padding: 16px;
                padding-right: 41px;
                position: relative;
              }

              .android .card-info .main-body{
                padding-right: 16px;
              }

              .card-info:active .main-body{
                background-color: whitesmoke;
              }

              .card-info .main-body .meta-blk {
                max-height: 57px;
                height: 57px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                line-height: 19px;
                font-size: 16px;
                letter-spacing: -0.43px;
              }

              .card-info .main-body .title {
                font-weight: bold;
                display: inline;
              }

              .card-info .main-body .title.lander{
                display: none;
              }

              .card-info .main-body .description {
                position: relative;
                max-height: 38px;
                height: 38px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .card-info .main-body .description.lander{
                display: none;
              }

              .card-info .main-body p {
                margin: 0;
              }

              .card-info .main-body .details-link {
                position: absolute;
                right: 16px;
                bottom: 50%;
                transform: translateY(50%);
                font-size: 27px;
                color: #767676;
              }

              .android .card-info .main-body .details-link {
                display: none;
              }

              .flb-layout.info-group .card-info {
                box-shadow: none;
                border-radius: 0;
              }

              .flb-layout.info-group .card-info .main-body .meta-blk {
                max-height: 80px;
                height: auto;
                -webkit-line-clamp: 4;
              }

              .flb-layout.info-group .card-info .main-body .title.carousel{
                display: none;
              }
              .flb-layout.info-group .card-info .main-body .title.lander{
                display: inline;
              }
              
              .flb-layout.info-group .card-info .main-body .description.carousel {
                display: none;
              }
              .flb-layout.info-group .card-info .main-body .description.lander{
                max-height: 57px;
                height: auto;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            `
          },
          detailsUI: {
            html: `
              <div class="details-page info" dmb="dmb" dmb:type="blk" v-track-custom-data="{content:{title:'details.title',category:'categoryName',location:'$moduleName'}}">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']">
                  <div class="category-icon" v-if="data && data.details.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.details.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                  <div class="category-icon" v-else-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                </div>
                <div class="main-content" dmb="dmb" dmb:type="blk">
                  <div class="title" dmb="dmb" dmb:type="text" v-if="data.details" role="heading" aria-level="1">{{data.details.title}}</div>
                  <div class="meta-wrap" dmb="dmb" dmb:type="blk">
                    <div class="meta-item date" v-if="data.details && data.details.startDate" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.dateIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Date."></div>
                      <div><span class="meta-value" dmb="dmb" dmb:type="text">{{data.details.startDate}}</span></div>
                    </div>
                    <div class="meta-item location" v-if="data.details && data.details.location" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.locationIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Location."></div> <div><span class="meta-value" dmb="dmb" dmb:type="text">{{data.details.location}}</span></div>
                    </div>
                  </div>
                  <div class="body-text body-wrap" v-if="data.details && data.details.body" v-rtf="data.details.body" dmb="dmb" dmb:type="textarea"></div>
                  <div class="body-text legal-wrap" v-rtf="data.details.legalCopy" v-if="data.details && data.details.legalCopy" dmb="dmb" dmb:type="textarea"></div>
                </div>
                <div class="con-wrap" v-if="data.details && data.details.buttons && data.details.buttons.length" dmb="dmb" dmb-spacer:style="width:100%;" dmb:type="blk">
                  <div class="button" v-bind:item-index="index" v-for="(button,index) in data.details.buttons" dmb="dmb" v-on:click.stop.prevent="emitAction(button.uri,{type:'button',name:button.label,compID:'btn'+index})" role="button">
                    <div class="inner-btn" dmb="dmb" dmb:type="text">{{button.label}}</div>
                  </div>
                </div>
              </div>
            `,
            css: /*css*/`
              .details-page.info {
                position: relative;
                background-color: #F3F3F3;
              }
              .details-page.info .img-blk {
                position: relative;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                height: 180px;
                border-bottom: 1px solid #cccccc;
              }
              
              .details-page.info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 50px;
                height: 50px;
                position: absolute;
                transform: translateY(-50%);
                top: 180px;
                right: 20px;
              }
              
              .details-page.info .main-content {
                padding: 45px 16px 0px 16px;
                color: #1c1c1c;
                background-color: white;
              }
              
              .details-page.info .main-content .title {
                font-size: 21px;
                line-height: 25px;
                font-weight: 500;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .meta-wrap {
                font-size: 16px;
                color: #555555;
                margin-top: 20px;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item {
                margin-bottom: 10px;
                display: grid;
                grid-template-columns: 30px auto;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item span,
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                vertical-align: middle
              }
              
              .details-page.info .main-content .meta-wrap .meta-item:last-of-type {
                margin-bottom: 0;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                position: relative;
                width: 20px;
                height: 20px;
                display: inline-block;
                background-size: cover;
                background-position: center;
                vertical-align: middle;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item .meta-value {
                display: inline-block;
                line-height: 20px;
                font-size: 16px;
                vertical-align: middle;
              }
              
              .details-page.info .main-content .body-text {
                padding-top: 20px;
                font-size: 16px;
                line-height: 22px;
                color: black;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .body-text ul {
                padding-inline-start: 30px;
              }
              
              .details-page.info .main-content .body-wrap {
                border-top: 1px solid #cccccc;
                margin-top: 20px;
                overflow: hidden;
              }
              
              .con-wrap {
                position: relative;
                background-color: white;
                padding: 20px 16px;
              }
              
              .con-wrap .button {
                text-align: center;
                border: 1px solid #008a00;
                color: #008a00;
                font-size: 17px;
                letter-spacing: -0.43px;
                padding: 12px 0;
                margin-bottom: 16px;
                cursor: pointer;
              }

              .con-wrap .button:first-of-type {
                background-color: #008a00;
                color: white;
                font-weight: bold;
              }
              .con-wrap .button:last-of-type {
                margin-bottom: 0;
              }
              
              .con-wrap .button:active {
                background-color: #1A5336;
                color: white;
                border: 1px solid #1A5336;
              }

              @media (min-width: 710px) {
                .details-page.info{
                  padding: 32px 64px;
                }
                .con-wrap {
                  padding: 20px 64px;
                }
                .con-wrap .button{
                  max-width: 330px;
                }
              }
              @media (min-width: 810px) {
                .details-page.info .img-blk {
                  height: 300px;
                }
                .details-page.info .category-icon {
                  right: 70px;
                  top: 300px;
                }
                .details-page.info .main-content {
                  padding: 45px 70px 120px 70px;
                }
              }
            `
          }
        },
        {
          key: 'td-for-me',
          defaultUI: {
            html: `
              <div class="card-base card-info education" dmb="dmb" dmb:type="blk" v-on:click="emitAction('details://?title='+data.categoryName,{type:'card',name:'card',compID:'card'})" role="button" tabindex="0">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']"></div>
                <div class="category-icon" v-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                <div class="main-body" v-if="data" dmb="dmb" dmb:type="blk">
                  <div class="meta-blk" dmb="dmb" dmb:type="blk" dmb:style="max-height:none;-webkit-line-clamp:initial;">
                    <div class="carousel title dmb-text" v-if="data.carousel && data.carousel.title" dmb="dmb" dmb:type="text">{{data.carousel.title}}</div dmb="dmb">
                    <div class="lander title dmb-text" v-if="data.lander && data.lander.title" dmb="dmb" dmb:type="text">{{data.lander.title}}</div dmb="dmb">
                    <br/>
                    <div class="carousel description dmb-textarea" v-if="data.carousel && data.carousel.description" v-rtf="data.carousel.description" dmb="dmb" dmb:type="textarea"></div>
                    <div class="lander description dmb-textarea" v-if="data.lander && data.lander.description" v-rtf="data.lander.description" dmb="dmb" dmb:type="textarea"></div>
                  </div>
                  <div class="details-link" dmb="dmb" dmb:type="icon" aria-hidden="true">›</div>
                </div>
              </div>
            `,
            css: /*css*/`
              .card-info.card-base {
                margin: 0;
                position: relative;
                width: 100%;
                margin: 0;
                border-radius: 8px;
                overflow: hidden;
                background-color: white;
                border: none;
                box-shadow: 0px 1px 4px 0px rgba(28, 28, 28, 0.03),
                            0px 1px 8px 0px rgba(28, 28, 28, 0.06);
                color: #1c1c1c;
                cursor: pointer;
              }

              .card-info::after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }

              .card-info .img-blk {
                position: relative;
                height: 130px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-bottom: 1px solid #CCCCCC;
              }

              .card-info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 40px;
                height: 40px;
                position: absolute;
                transform: translateY(-50%);
                top: 130px;
                right: 16px;
                z-index: 1;
              }

              .card-info .main-body {
                padding: 16px;
                padding-right: 41px;
                position: relative;
              }

              .android .card-info .main-body{
                padding-right: 16px;
              }

              .card-info:active .main-body{
                background-color: whitesmoke;
              }

              .card-info .main-body .meta-blk {
                max-height: 57px;
                height: 57px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                line-height: 19px;
                font-size: 16px;
                letter-spacing: -0.43px;
              }

              .card-info .main-body .title {
                font-weight: bold;
                display: inline;
              }

              .card-info .main-body .title.lander{
                display: none;
              }

              .card-info .main-body .description {
                position: relative;
                max-height: 38px;
                height: 38px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .card-info .main-body .description.lander{
                display: none;
              }

              .card-info .main-body p {
                margin: 0;
              }

              .card-info .main-body .details-link {
                position: absolute;
                right: 16px;
                bottom: 50%;
                transform: translateY(50%);
                font-size: 27px;
                color: #767676;
              }

              .android .card-info .main-body .details-link {
                display: none;
              }

              .flb-layout.info-group .card-info {
                box-shadow: none;
                border-radius: 0;
              }

              .flb-layout.info-group .card-info .main-body .meta-blk {
                max-height: 80px;
                height: auto;
                -webkit-line-clamp: 4;
              }

              .flb-layout.info-group .card-info .main-body .title.carousel{
                display: none;
              }
              .flb-layout.info-group .card-info .main-body .title.lander{
                display: inline;
              }
              
              .flb-layout.info-group .card-info .main-body .description.carousel {
                display: none;
              }
              .flb-layout.info-group .card-info .main-body .description.lander{
                max-height: 57px;
                height: auto;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            `
          },
          detailsUI: {
            html: `
              <div class="details-page info" dmb="dmb" dmb:type="blk" v-track-custom-data="{content:{title:'details.title',category:'categoryName',location:'$moduleName'}}">
                <div class="img-blk" v-if="data && data.mainImg" v-bind:style="{backgroundImage: 'url('+data.mainImg+')'}" dmb="dmb" dmb:type="banner" v-bind:role="[data && data.mainImgAltText?'img':'']" v-bind:aria-label="[data && data.mainImgAltText?data.mainImgAltText:'']">
                  <div class="category-icon" v-if="data && data.details.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.details.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                  <div class="category-icon" v-else-if="data && data.categoryIcon" v-bind:style="{backgroundImage: 'url('+data.categoryIcon+')'}" dmb="dmb" dmb:type="icon"></div>
                </div>
                <div class="main-content" dmb="dmb" dmb:type="blk">
                  <div class="title" dmb="dmb" dmb:type="text" v-if="data.details" role="heading" aria-level="1">{{data.details.title}}</div>
                  <div class="meta-wrap" dmb="dmb" dmb:type="blk">
                    <div class="meta-item date" v-if="data.details && data.details.startDate" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.dateIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Date."></div>
                      <div><span class="meta-value" dmb="dmb" dmb:type="text" dmb:size="10">{{data.details.startDate}}</span></div>
                    </div>
                    <div class="meta-item location" v-if="data.details && data.details.location" dmb="dmb" dmb:type="blk" dmb:style="display:block;" dmb-spacer:style="display:grid;grid-template-columns:30px auto;" role="text" tabindex="0">
                      <div v-bind:style="{backgroundImage: 'url('+data.details.locationIcon+')'}" class="meta-icon" dmb="dmb" dmb:type="icon" aria-label="Location."></div> <div><span class="meta-value" dmb="dmb" dmb:type="text">{{data.details.location}}</span></div>
                    </div>
                  </div>
                  <div class="body-text body-wrap" v-if="data.details && data.details.body" v-rtf="data.details.body" dmb="dmb" dmb:type="textarea"></div>
                  <div class="body-text legal-wrap" v-rtf="data.details.legalCopy" v-if="data.details && data.details.legalCopy" dmb="dmb" dmb:type="textarea"></div>
                </div>
                <div class="con-wrap" v-if="data.details && data.details.buttons && data.details.buttons.length" dmb="dmb" dmb-spacer:style="width:100%;" dmb:type="blk">
                  <div class="button" v-bind:item-index="index" v-for="(button,index) in data.details.buttons" dmb="dmb" v-on:click.stop.prevent="emitAction(button.uri,{type:'button',name:button.label,compID:'btn'+index})" role="button">
                    <div class="inner-btn" dmb="dmb" dmb:type="text">{{button.label}}</div>
                  </div>
                </div>
              </div>
            `,
            css: /*css*/`
              .details-page.info {
                position: relative;
                background-color: #F3F3F3;
              }  
              .details-page.info .img-blk {
                position: relative;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                height: 180px;
                border-bottom: 1px solid #cccccc;
              }
              
              .details-page.info .category-icon {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 50px;
                height: 50px;
                position: absolute;
                transform: translateY(-50%);
                top: 180px;
                right: 20px;
              }
              
              .details-page.info .main-content {
                padding: 45px 16px 0px 16px;
                color: #1c1c1c;
                background-color: white;
              }
              
              .details-page.info .main-content .title {
                font-size: 21px;
                line-height: 25px;
                font-weight: 500;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .meta-wrap {
                font-size: 16px;
                color: #555555;
                margin-top: 20px;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item {
                margin-bottom: 10px;
                display: grid;
                grid-template-columns: 30px auto;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item span,
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                vertical-align: middle
              }
              
              .details-page.info .main-content .meta-wrap .meta-item:last-of-type {
                margin-bottom: 0;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item .meta-icon {
                position: relative;
                width: 20px;
                height: 20px;
                display: inline-block;
                background-size: cover;
                background-position: center;
                vertical-align: middle;
              }
              
              .details-page.info .main-content .meta-wrap .meta-item .meta-value {
                display: inline-block;
                line-height: 20px;
                font-size: 16px;
                vertical-align: middle;
              }
              
              .details-page.info .main-content .body-text {
                padding-top: 20px;
                font-size: 16px;
                line-height: 22px;
                color: black;
                letter-spacing: -0.43px;
              }
              
              .details-page.info .main-content .body-text ul {
                padding-inline-start: 30px;
              }
              
              .details-page.info .main-content .body-wrap {
                border-top: 1px solid #cccccc;
                margin-top: 20px;
                overflow: hidden;
              }
              
              .con-wrap {
                position: relative;
                background-color: white;
                padding: 20px 16px;
              }

              .con-wrap .button {
                text-align: center;
                border: 1px solid #008a00;
                color: #008a00;
                font-size: 17px;
                letter-spacing: -0.43px;
                padding: 12px 0;
                margin-bottom: 16px;
                cursor: pointer;
              }
              
              .con-wrap .button:first-of-type {
                background-color: #008a00;
                color: white;
                font-weight: bold;
              }
              .con-wrap .button:last-of-type {
                margin-bottom: 0;
              }
              
              .con-wrap .button:active {
                background-color: #1A5336;
                color: white;
                border: 1px solid #1A5336;
              }

              @media (min-width: 710px) {
                .details-page.info{
                  padding: 32px 64px;
                }
                .con-wrap {
                  padding: 20px 64px;
                }
                .con-wrap .button{
                  max-width: 330px;
                }
              }
              @media (min-width: 810px) {
                .details-page.info .img-blk {
                  height: 300px;
                }
                .details-page.info .category-icon {
                  right: 70px;
                  top: 300px;
                }
                .details-page.info .main-content {
                  padding: 45px 70px 120px 70px;
                }
              }
            `
          }
        },
        {
          key: 'text-link',
          defaultUI: {
            html: `
              <div class="card-textlink" dmb="dmb" dmb:type="blk">
                <div class="img-blk" v-if="data" v-bind:style="{backgroundImage: 'url('+data.image+')'}" dmb="dmb" dmb:type="banner"></div>
                <div class="main-body" v-if="data" dmb="dmb" dmb:type="blk">
                  <div class="header" v-if="data" dmb="dmb" dmb:type="text">{{data.header || ""}}</div>
                  <div class="title" v-if="data" dmb="dmb" dmb:type="text">{{data.title || ""}}</div>
                  <div class="description" v-if="data" v-rtf="data.description || ''" dmb="dmb" dmb:type="textarea"></div>
                  <div class="action" v-if="data" dmb="dmb" dmb:type="textbutton">{{data.link?data.link.text:""}}</div>
                </div>
              </div>
            `,
            css: `
              .card-textlink{
                position: relative;
                min-height: 200px;
                width: 100%;
                margin: 0 10px;
                border-radius: 5px;
                overflow: hidden;
                background-color: transparent;
                color: #3f3f3f;
              }
              .card-textlink:hover .img-blk{
                box-shadow: 0 2px 5px rgba(0,0,0,0.24);
              }
              .card-textlink .img-blk{
                border-radius: 15px;
              }
              .card-textlink::after{
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }
              .card-textlink .img-blk{
                position: relative;
                height: 130px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
              }
              .card-textlink .main-body {
                padding: 10px 0;
              }
              .card-textlink .main-body .header {
                font-size: 12px;
                padding: 5px 0;
              }
              .card-textlink .main-body .title {
                font-weight: bold;
                color: black;
                font-size: 14px;
                padding: 5px 0 10px 0;
              }
              .card-textlink .main-body .action {
                cursor: pointer;
                color: #0c94f2;
                font-weight: bold;
                font-size: 12px;
                margin-top: 10px;
              }
              .card-textlink .main-body .description{
                font-size: 12px;
              }
            `
          },
          detailsUI: {
            html: ``,
            css: ``
          }
        },
        {
          key: 'button-link',
          defaultUI: {
            html: `
              <div class="dmb-shell card-buttonlink" dmb="dmb" dmb:type="blk">
                <div class="dmb-icon card-buttonlink__image" dmb="dmb" dmb:type="icon" v-bind:style="{backgroundImage: 'url('+data.image+')'}"></div>
                <div class="dmb-shell card-buttonlink__content" dmb="dmb" dmb:type="blk">
                  <div class="dmb-shell card-buttonlink__content__header" dmb="dmb" dmb:type="blk">
                    <div class="dmb-text" dmb="dmb" dmb:type="text" dmb:size="40">{{data.header}}</div>
                  </div>
                  <div class="dmb-shell card-buttonlink__content__title" dmb="dmb" dmb:type="blk">
                    <div class="dmb-text" dmb="dmb" dmb:type="text">{{data.title}}</div>
                  </div>
                  <div class="dmb-shell card-buttonlink__content__description" dmb="dmb" dmb:type="blk">
                    <div class="dmb-textarea" dmb="dmb" dmb:type="textarea" v-rtf="data.description"/>
                  </div>
                </div>
                <div class="dmb-shell card-buttonlink__actions" dmb="dmb" dmb:type="blk">
                  <div class="dmb-button primary" dmb="dmb" dmb:type="primarybutton" v-on:click="emitAction(null)">{{data.buttons[0].text}}</div>
                </div>
                <div class="dmb-shell card-buttonlink__actions" dmb="dmb" dmb:type="blk">
                  <div class="dmb-button secondary" dmb="dmb" dmb:type="secondarybutton" v-on:click="emitAction(null)">{{data.buttons[1].text}}</div>
                </div>
              </div>
            `,
            css: /*css*/`
              .dmb-button.primary {
                background-color: #0851DF;
                border: 1px solid #3258E9;
                color: white;
                text-align: center;
                border-radius: 4px;
                cursor: pointer;
                padding: 7px 0;
              }
              
              .dmb-button.primary:hover,
              .dmb-button.primary:active {
                background-color: #1237B5;
              }
              
              .dmb-button.secondary {
                border: 1px solid #0851DF;
                color: #0851DF;
                text-align: center;
                border-radius: 4px;
                cursor: pointer;
                padding: 7px 0;
              }
              
              .dmb-button.secondary:hover,
              .dmb-button.secondary:active {
                background-color: #DDECFF;
                color: #1237B5;
              }
              
              .dmb-text {
                clear: both;
              }
              
              .dmb-icon {
                position: relative;
                display: inline-block;
                width: 30px;
                height: 30px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
              }
              
              .dmb-shell:after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }
              
              .card-buttonlink {
                margin: 16px 0;
                border-radius: 10px;
                background-color: #fff;
                box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.1);
              }
              
              .card-buttonlink__image {
                background-size: cover;
                width: 100%;
                height: 120px;
                border-radius: 10px 10px 0 0;
              }
              
              .card-buttonlink__content {
                padding: 10px 10px 14px 10px
              }
              
              .card-buttonlink__content__header {
                font-size: 10px;
                font-weight: 500;
                letter-spacing: 1.85px;
                line-height: 12px;
                text-transform: uppercase;
                color: #697186;
                overflow-wrap: break-word;
              }
              
              .card-buttonlink__content__title {
                margin-top: 5px;
                font-size: 14px;
                font-weight: 700;
                line-height: 15px;
                color: #333333;
                overflow-wrap: break-word;
              }
              
              .card-buttonlink__content__description {
                margin: 12px 0 24px 0;
                font-size: 12px;
                font-weight: 400;
                line-height: 13px;
                color: #848688;
                overflow-wrap: break-word;
              }
              
              .card-buttonlink__actions {
                padding: 6px 0;
                grid-gap: 6px;
                gap: 6px;
              }
            `
          },
          detailsUI: {
            html: ``,
            css: ``
          }
        },
        {
          key: 'banner',
          defaultUI: {
            html: `
              <div class="card-textlink" dmb="dmb" dmb:type="blk">
                <div class="img-blk" v-if="data" v-bind:style="{backgroundImage: 'url('+data.image+')'}" dmb="dmb" dmb:type="banner"></div>
                <div class="main-body" v-if="data" dmb="dmb" dmb:type="blk">
                  <div class="header" v-if="data" dmb="dmb" dmb:type="text">{{data.header || ""}}</div>
                  <div class="title" v-if="data" dmb="dmb" dmb:type="text">{{data.title || ""}}</div>
                  <div class="description" v-if="data" v-rtf="data.description || ''" dmb="dmb" dmb:type="textarea"></div>
                  <div class="action" v-if="data" dmb="dmb" dmb:type="textbutton">{{data.link?data.link.text:""}}</div>
                </div>
              </div>
            `,
            css: `
              .card-textlink{
                position: relative;
                min-height: 100px;
                width: 100%;
                margin: 0 10px;
                border-radius: 15px;
                overflow: hidden;
                background-color: white;
                color: #3f3f3f;
              }
              .card-textlink:hover .img-blk{
                box-shadow: 0 2px 5px rgba(0,0,0,0.24);
              }
              .card-textlink::after{
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }
              .card-textlink .img-blk{
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                width: 33.3333%;
                background-size: cover;
                background-repeat: no-repeat;
                height: 100%;
                background-position: left;
              }
              .card-textlink .main-body {
                width: 66.6666%;
                box-sizing: border-box;
                padding: 14px;
              }
              .card-textlink .main-body .header {
                font-size: 12px;
                padding: 0 0 2px 0;
              }
              .card-textlink .main-body .title {
                font-weight: bold;
                color: black;
                font-size: 14px;
                padding: 5px 0 5px 0;
              }
              .card-textlink .main-body .action {
                cursor: pointer;
                color: #0c94f2;
                font-weight: bold;
                font-size: 12px;
                margin-top: 10px;
              }
              .card-textlink .main-body .description{
                font-size: 12px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            `
          },
          detailsUI: {
            html: ``,
            css: ``
          }
        },
        {
          key: 'hero',
          defaultUI: {
            html: `
              <div class="card-highlight" dmb="dmb" dmb:type="blk">
                <div class="img-blk" v-if="data" v-bind:style="{backgroundImage: 'url('+data.image+')'}" dmb="dmb" dmb:type="banner"></div>
                <div class="main-body" v-if="data" dmb="dmb" dmb:type="blk" dmb-spacer:style="height: 60px;">
                  <div class="header" v-if="data" dmb="dmb" dmb:type="text">{{data.header || ""}}</div>
                  <div class="title" v-if="data" dmb="dmb" dmb:type="text" dmb:style="height: 40px;">{{data.title || ""}}</div>
                </div>
              </div>
            `,
            css: `
              .card-highlight {
                position: relative;
                aspect-ratio: 4/2.3;
                box-shadow: none;
                border: none;
                cursor: pointer;
                user-select: none;
                width: 100%;
                border-radius: 5px;
                overflow: hidden;
              }
              
              .card-highlight .img-blk {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-size: cover;
                background-position: center
              }
              
              .card-highlight .main-body {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                color: #fff;
                padding: 20px 20px 30px;
                z-index: 1
              }
              
              .card-highlight .main-body .header,
              .card-highlight .main-body .title,
              .card-highlight .main-body [dmb=dmb] {
                position: relative;
                z-index: 2
              }
              
              .card-highlight .main-body .header {
                font-size: 12px;
                margin-bottom: 5px
              }
              
              .card-highlight .main-body .title {
                white-space: pre-wrap;
                line-height: 25px
              }
              
              .card-highlight .main-body::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 120%;
                background: linear-gradient(rgba(0, 0, 0, 0), #000);
                z-index: 1
              }
            `
          },
          detailsUI: {
            html: ``,
            css: ``
          }
        },
        {
          key: 'alert-card',
          defaultUI: {
            html: `
              <div class="dmb-shell alart-card card-base" dmb="dmb" dmb:type="blk">
                <div class="header-blk">
                  <div class="dismiss-btn">×</div>
                  <div class="more-menu">⠇</div>
                </div>
                <div class="inner-shell dmb-shell" dmb="dmb" dmb:type="blk" dmb-spacer:style="display:grid;grid-template-columns:50px auto;gap:10px;">
                  <div class="dmb-icon" dmb="dmb" dmb:type="icon" v-bind:style="{backgroundImage: 'url('+data.icon+')'}" style=""></div>
                  <div class="meta-wrap dmb-shell" dmb="dmb" dmb:type="blk">
                    <div class="dmb-textarea" dmb="dmb" dmb:type="textarea" style="" v-rtf="data.description"></div>
                    <div class="dmb-button text" dmb="dmb" dmb:type="textbutton" v-on:click="emitAction(data.textlink.uri)" style="">{{data.textlink.label}}</div>
                  </div>
                </div>
              </div>
            `,
            css: `
              .alart-card.card-base {
                background-color: white;
                margin: 0;
                padding: 20px;
              }
              
              .alart-card .header-blk {
                overflow: hidden;
                margin-bottom: 15px;
              }
              
              .alart-card .header-blk .dismiss-btn {
                float: left;
                font-size: 30px;
                line-height: 20px;
              }
              
              .alart-card .header-blk .more-menu {
                float: right;
                font-size: 20px;
                line-height: 20px;
              }
              
              .alart-card .dmb-button.text {
                color: #207506;
                font-weight: 500;
                margin-top: 20px;
                cursor: pointer;
              }
              
              .alart-card .dmb-icon {
                position: relative;
                display: inline-block;
                width: 50px;
                height: 50px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
              }
              
              .alart-card .inner-shell {
                display: grid;
                grid-template-columns: 50px auto;
                gap: 0 10px;
              }
              
              .dmb-button.text:hover,
              .dmb-button.text:active {
                color: #1b6405;
              }
              
              .dmb-textarea {
                display: block;
              }
              
              .dmb-textarea p {
                margin: 0;
              }
              
              .dmb-shell:after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }
            `
          }
        },
        {
          key: 'custom',
          defaultUI: {
            html: `
              <div class="dmb-shell" dmb="dmb" dmb:type="blk"></div>
            `,
            css: /*css*/`
              .dmb-shell:after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }
            `
          },
          detailsUI: {
            html: `
              <div class="dmb-shell" dmb="dmb" dmb:type="blk"></div>
            `,
            css: /*css*/`
              .dmb-shell:after {
                content: "";
                visibility: hidden;
                display: block;
                height: 0;
                clear: both;
              }
            `
          },
        }
      ],
      uiComponents: [
        {
          key: 'container',
          label: 'Container',
          icon: 'images/Component-Custom_Container.png',
          category: 'blocks',
          html: '<div class="dmb-shell" dmb="dmb" dmb:type="blk"></div>',
          css: /*css*/`
            .dmb-shell:after {
              content: "";
              visibility: hidden;
              display: block;
              height: 0;
              clear: both;
            }
          `
        },
        {
          key: 'primarybutton',
          label: 'Primary Button',
          icon: 'images/Component-Buttons_Primary.png',
          category: 'buttons',
          html: `
            <div class="dmb-button primary" dmb="dmb" dmb:type="primarybutton">
              <div class="inner-btn text"></div>
            </div>
          `,
          css: /*css*/`
            .dmb-button.primary {
              background-color: #3258E9;
              border: 1px solid #3258E9;
              color: white;
              text-align: center;
              border-radius: 4px;
              cursor: pointer;
              padding: 7px 0;
            }
            .dmb-button.primary:hover,.dmb-button.primary:active {
              background-color: #4432e9;
            }
          `
        },
        {
          key: 'secondarybutton',
          label: 'Secondary Button',
          icon: 'images/Component-Buttons_Secondary.png',
          category: 'buttons',
          html: `
            <div class="dmb-button secondary" dmb="dmb" dmb:type="secondarybutton">
              <div class="inner-btn text"></div>
            </div>
          `,
          css: /*css*/`
            .dmb-button.secondary {
              background-color: transparent;
              border: 1px solid #3258E9;
              color: white;
              text-align: center;
              border-radius: 4px;
              cursor: pointer;
              padding: 7px 0;
            }
            .dmb-button.secondary:hover,.dmb-button.secondary:active {
              background-color: #4432e9;
            }
          `
        },
        {
          key: 'textbutton',
          label: 'Text Button',
          icon: 'images/Component-Buttons_Text.png',
          category: 'buttons',
          html: `
            <div class="dmb-button text" dmb="dmb" dmb:type="textbutton">
              <div class="inner-btn text-blk"></div>
            </div>
          `,
          css: `
            .dmb-button.text {
              text-decoration: underline;
              color: #3258E9
            }
            .dmb-button.text:hover,.dmb-button.text:active {
              color: #4432e9;
            }
          `
        },
        {
          key: 'text',
          label: 'Text Field',
          icon: 'images/Component-Text_Header.png',
          category: 'text',
          html: '<div class="dmb-text" dmb="dmb" dmb:type="text"></div>',
          css: `
            .dmb-text {
              display: inline-block;
              clear: both;
            }
          `
        },
        {
          key: 'textarea',
          label: 'Text Area',
          icon: 'images/Component-Text_Description.png',
          category: 'text',
          html: '<div class="dmb-textarea" dmb="dmb" dmb:type="textarea"></div>',
          css: `
            .dmb-textarea {
              display: block;
            }
            .dmb-textarea p {
              margin: 0;
            }
          `
        },
        {
          key: 'icon',
          label: 'Icon',
          icon: 'images/Component-Images_Icon.png',
          category: 'images',
          html: '<div class="dmb-icon" dmb="dmb" dmb:type="icon"></div>',
          css: `
            .dmb-icon {
              position: relative;
              display: inline-block;
              width: 30px;
              height: 30px;
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }
          `
        },
        {
          key: 'banner',
          label: 'Banner',
          icon: 'images/Component-Images_Banner.png',
          category: 'images',
          html: '<div class="dmb-banner" dmb="dmb" dmb:type="banner"></div>',
          css: `
            .dmb-banner {
              min-height: 120px;
              position: relative;
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }
          `
        },
        {
          key: 'textinput',
          label: 'Text Input',
          icon: 'images/TextInput_Icon.png',
          category: 'input',
          html: `
            <div class="dmb-inputgroup textinput" dmb="dmb" dmb:type="textinput">
              <div class="dmb-inputlabel" dmb:type="inputlabel"></div>
              <input type="text" class="dmb-input text">
            </div>
          `,
          css: `
            .dmb-inputgroup.textinput{
              margin: 10px 0;
            }
            .dmb-inputgroup.textinput .dmb-inputlabel{
              font-weight: bold;
              margin-bottom: 5px;
              font-size: 13px;
            }
            .dmb-inputgroup.textinput .dmb-input.text {
              box-sizing: border-box;
              width: 100%;
              line-height: 24px;
            }
          `
        },
        {
          key: 'textareainput',
          label: 'Text Area Input',
          icon: 'images/TextArea_Icon.png',
          category: 'input',
          html: `
            <div class="dmb-inputgroup textareainput" dmb="dmb" dmb:type="textareainput">
              <div class="dmb-inputlabel" dmb:type="inputlabel"></div>
              <textarea class="dmb-input textarea"></textarea>
            </div>
          `,
          css: `
            .dmb-inputgroup.textareainput{
              margin: 10px 0;
            }
            .dmb-inputgroup.textareainput .dmb-inputlabel{
              font-weight: bold;
              margin-bottom: 5px;
              font-size: 13px;
            }
            .dmb-inputgroup.textareainput .dmb-input.textarea {
              box-sizing: border-box;
              max-width: 100%;
              min-width: 100%;
              height: 40px;
              line-height: 18px;
            }
          `
        },
        {
          key: 'rangeinput',
          label: 'Slider',
          icon: 'images/Slider_Icon.png',
          category: 'input',
          html: `
            <div class="dmb-inputgroup rangeinput" dmb="dmb" dmb:type="rangeinput">
              <div class="dmb-inputlabel" dmb:type="inputlabel"></div>
              <input type="range" class="dmb-input slider">
            </div>
          `,
          css: `
            .dmb-inputgroup.rangeinput{
              margin: 10px 0;
            }
            .dmb-inputgroup.rangeinput .dmb-inputlabel{
              font-weight: bold;
              margin-bottom: 5px;
              font-size: 13px;
            }
            .dmb-inputgroup.rangeinput .dmb-input.slider {
              box-sizing: border-box;
              width: 100%;
            }
          `
        },
        {
          key: 'checkboxinput',
          label: 'Checkbox',
          icon: 'images/checkbox_icon.png',
          category: 'input',
          html: `
            <div class="dmb-inputgroup checkbox" dmb="dmb" dmb:type="checkboxinput">
              <input type="checkbox" class="dmb-input checkbox">
              <div class="dmb-inputlabel" dmb:type="inputlabel"></div>
            </div>
          `,
          css: `
            .dmb-inputgroup.checkbox{
              margin: 5px 0;
            }
            .dmb-inputgroup.checkbox .dmb-inputlabel{
              display: inline-block;
              padding: 0 10px;
              vertical-align: middle;
              font-size: 16px;
            }
            .dmb-inputgroup.checkbox .dmb-input.checkbox {
              box-sizing: border-box;
              vertical-align: middle;
            }
          `
        },
        {
          key: 'radioinput',
          label: 'Radio',
          icon: 'images/Selection_Icon.png',
          category: 'input',
          html: `
            <div class="dmb-inputgroup radio" dmb="dmb" dmb:type="radioinput">
              <label>
                <input type="radio" class="dmb-input radio">
                <div class="dmb-inputlabel" dmb:type="inputlabel"></div>
              </label>
            </div>
          `,
          css: `
            .dmb-inputgroup.radio{
              margin: 5px 0;
            }
            .dmb-inputgroup.radio .dmb-inputlabel{
              display: inline-block;
              padding: 0 10px;
              vertical-align: middle;
              font-size: 16px;
            }
            .dmb-inputgroup.radio .dmb-input.radio {
              box-sizing: border-box;
              vertical-align: middle;
            }
          `
        },
      ],
      moduleTemplates: [
        {
          key: 'carousel',
          label: 'Carousel',
          img: 'images/layout-carousel.png',
          html: `
            <div class="zone1" v-track-module v-track-custom-data="{content:{title:'carousel.title',category:'categoryName',location:'$moduleName'}}"> 
              <flybits-carousel v-bind:class="[content.length > 1?'multi':'']" v-bind:content="content"></flybits-carousel>
            </div>
          `,
          css: /*css*/`
            .zone1 {
              background-color: #F3F3F3;
            }

            .zone1 .flb-carousel .scroll-wrap,
            .zone1 .flb-horizontal .scroll-wrap {
              min-height: 70px;
              padding-top: 12px;
              padding-bottom: 12px;
              scroll-snap-type: x mandatory;
            }

            .zone1 .flb-carousel .flb-viewable,
            .zone1 .flb-horizontal .flb-viewable {
              width: 100%;
              scroll-snap-align: center;
              box-sizing: border-box;
              padding: 0 6px;
            }

            .zone1 .flb-carousel .flb-viewable:first-of-type,
            .zone1 .flb-horizontal .flb-viewable:first-of-type {
              padding-left: 16px;
              padding-right: 16px;
            }

            .android .zone1 .flb-carousel .flb-viewable:first-of-type,
            .android .zone1 .flb-horizontal .flb-viewable:first-of-type {
              padding-left: 8px;
              padding-right: 8px;
            }

            .zone1 .flb-carousel.multi .flb-viewable,
            .zone1 .flb-horizontal.multi .flb-viewable {
              width: 86.5%;
              box-sizing: unset;
            }

            @media (min-width: 520px) {

              .zone1 .flb-carousel.multi .flb-viewable,
              .zone1 .flb-horizontal.multi .flb-viewable {
                width: 343px;
                box-sizing: unset;
              }
            }

            .zone1 .flb-carousel.multi .flb-viewable:first-of-type,
            .zone1 .flb-horizontal.multi .flb-viewable:first-of-type {
              padding-right: 6px;
            }

            .zone1 .flb-carousel.multi .flb-viewable:last-of-type,
            .zone1 .flb-horizontal.multi .flb-viewable:last-of-type {
              padding-right: 16px;
            }

            .android .zone1 .flb-carousel.multi .flb-viewable:last-of-type,
            .android .zone1 .flb-horizontal.multi .flb-viewable:last-of-type {
              padding-right: 8px;
            }
          `
        },
        {
          key: 'list',
          label: 'List',
          img: 'images/layout-list.png',
          html: ``,
          css: ``
        },
        {
          key: 'categorygroup',
          label: 'Category Group',
          img: 'images/layout-categorygroup.png',
          html: `
            <div class="flb-layout info-group" v-if="content.length" v-track-module v-track-custom-data="{content:{title:'lander.title',category:'categoryName',location:'$moduleName'}}">
              <div class="group-wrap">
                <div class="group-header" role="heading" aria-level="2">
                  <div class="category-icon" v-if="content.length" v-bind:style="{backgroundImage: 'url('+content[0].data.categoryIcon+')'}"></div>
                  <div class="category-label" v-if="content.length">{{content[0].data.categoryName}}</div>
                </div>
                <div class="group-content first"> <flybits-viewable v-for="(item, index) in content.slice(0,1)" v-bind:detailsUIConfig="item.detailsUIConfig" v-bind:id="index" v-bind:contentInfo="item.contentInfo" v-bind:key="item.id" v-bind:template="item.uiTemplate" v-bind:data="item.data" v-bind:styleURL="item.style" v-bind:styleStr="item.styleStr" v-bind:layout="item.layout" v-bind:ref="item.id" v-track-content></flybits-viewable> </div>
                <div class="group-content remaining" v-bind:class="[$props.index?'expanded':'']" v-if="content.length > 1"> <flybits-viewable v-for="(item, index) in content.slice(1)" v-bind:detailsUIConfig="item.detailsUIConfig" v-bind:id="index" v-bind:contentInfo="item.contentInfo" v-bind:key="item.id" v-bind:template="item.uiTemplate" v-bind:data="item.data" v-bind:styleURL="item.style" v-bind:styleStr="item.styleStr" v-bind:layout="item.layout" v-bind:ref="item.id" v-track-content></flybits-viewable> </div>
                <div class="group-footer">
                  <div class="expand-toggle" v-if="content.length > 1" v-on:click="$props.index= !$props.index" role="button" v-bind:aria-expanded="$props.index"> <span v-if="!$props.index">Show more ({{content.length - 1}})</span> <span v-else>Show less</span> </div>
                </div>
              </div>
            </div>
          `,
          css: /*css*/`
            .info-group {
              padding: 7px 16px 5px 16px;
              background-color: #F3F3F3;
            }
            .android .info-group{
              padding: 7px 8px 5px 8px;
            }

            .container>.flb-viewable:first-of-type .info-group {
              padding-top: 16px;
            }

            .container>.flb-viewable:last-of-type .info-group {
              padding-bottom: 16px;
            }

            .container>.flb-viewable .img-blk {
              display: none;
            }

            .container>.flb-viewable .group-header {
              border-bottom: 1px solid #cccccc;
            }

            .info-group .group-wrap {
              box-shadow: 0px 1px 4px 0px rgba(28, 28, 28, 0.03),
                          0px 1px 8px 0px rgba(28, 28, 28, 0.06);
              border-radius: 8px;
              background-color: white;
            }

            @media (min-width: 700px) {
              .info-group .group-wrap {
                max-width: 700px;
                margin-left: auto;
                margin-right: auto;
              }
            }

            @media (min-width: 1110px) {
              .info-group .group-wrap {
                max-width: 820px;
              }
            }

            .info-group .group-header {
              color: #1c1c1c;
              font-size: 19px;
              padding: 12px 16px 12px 16px;
              font-weight: 500;
              line-height: 40px;
              letter-spacing: -0.45px;
            }

            .info-group .group-header .category-icon {
              width: 40px;
              height: 40px;
              background-size: cover;
              background-position: center;
              display: inline-block;
              vertical-align: middle;
              margin-right: 5px;
            }

            .info-group .group-header .category-label {
              display: inline-block;
              vertical-align: middle;
            }

            .group-content.remaining {
              max-height: 0;
              transition: max-height 0.4s cubic-bezier(0.22, 1, 0.36, 1), visibility 0s linear 0.4s;
              overflow: hidden;
              visibility: hidden;
            }

            .group-content.remaining .flb-viewable {
              position: relative;
            }

            .group-content.remaining .flb-viewable::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 16px;
              right: 16px;
              height: 1px;
              background-color: #CCCCCC;
            }

            .group-content.remaining .flb-viewable:first-of-type::before{
              content: '';
              position: absolute;
              top: 0;
              left: 16px;
              right: 16px;
              height: 1px;
              background-color: #CCCCCC;
              z-index: 1;
            }

            .group-content.remaining .flb-viewable:last-of-type::after{
              display: none;
            }

            .group-content.remaining.expanded {
              max-height: 10000px;
              transition: max-height 0.5s cubic-bezier(0.64, 0, 0.78, 0), visibility 0s linear 0s;
              visibility: visible;
            }

            .info-group .card-base {
              box-shadow: none;
              border-radius: 0;
            }

            .info-group .card-base .category-icon {
              display: none;
            }

            .info-group .group-footer {
              height: 45px;
              border-top: 1px solid #cccccc;
            }

            .info-group .group-footer .expand-toggle {
              float: right;
              font-size: 13px;
              font-weight: 600;
              letter-spacing: -0.08px;
              line-height: 45px;
              padding: 0 16px 0 0;
              cursor: pointer;
              color: #038203;
              padding-left: 16px;
            }
          `
        }
      ]
    },
    getters: {
      getLayoutByKey: function(state){
        return function(uiTemplateKey){
          return state.uiTemplates.filter(function(t){
            return t.key === uiTemplateKey;
          })[0];
        };
      },
      getComponentByKey: function(state){
        return function(componentKey){
          return state.uiComponents.filter(function(comp){
            return comp.key === componentKey;
          })[0];
        }
      },
      getModuleLayoutByKey: function(state){
        return function(layoutKey){
          return state.moduleTemplates.filter(function(t){
            return t.key === layoutKey;
          })[0];
        }
      }
    }
  }
})();
var ContextStore = (function(){
  var deferredInit = new Deferred();

  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      contextPlugins: []
    },
    getters: {
      contextAttributes: function(state){
        var retAttrs = [];
        state.contextPlugins.forEach(function(plugin){
          plugin.attributes.forEach(function(attribute){
            retAttrs.push({
              pluginIcon: plugin.iconURL,
              pluginID: plugin.id,
              pluginName: plugin.name,
              name: attribute.name,
              id: attribute.id,
              type: attribute.type,
              params: attribute.parameters
            });
          });
        });
        return retAttrs;
      }
    },
    mutations: {
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      },
      setPlugins: function(state, contextPlugins){
        state.contextPlugins = contextPlugins;
      }
    },
    actions: {
      hydrate: function(context){
        var def = new Deferred();

        Flybits.api.ContextPlugin.getAll().then(function(plugins){
          context.commit('setPlugins', plugins);
          context.commit('setInitialized');
        }).catch(function(e){
          console.log('> uh oh', e);
          App.toast('Failed to load Context Attributes','error');
        });

        return def.promise;
      }
    }
  }
})();
var App = (function(){
  var deferredReady = new Deferred();

  var App = {
    ready: deferredReady.promise,
    vm: null,
    evt: null,
    ext:{
      CONFIG:"res/config.json",
      VERSION: 'version.txt'
    },
    actions:{
      LOADING: "loading",
      CONFIG_UPDATE: "configupdated",
      VIBRATE: 'vibrate',
      OPENMANAGEIMAGE: 'open_manage_image',
      CHOOSELOCATION: 'choose_location',
      SENDMSG: 'send_message',
      ONMSG: 'on_message'
    },
    util: {},
    checkVersion: function(){
      fetch(this.ext.VERSION).then(function(resp){
        return resp.text();
      }).then(function(fileStr){
        App.vm.version = fileStr;
        console.debug(fileStr);
      });
    },
    toast: function(msg, msgType, duration){
      msgType = msgType || 'normal';

      if(typeof msg === 'object'){
        try{
          msg = JSON.stringify(msg);
        } catch(e){
          console.log('> toast stringify fail', e);
        }
      }

      var opt = {
        text: msg,
        gravity: 'bottom',
        duration: 3000,
        offset: {
          y: 50
        }
      };
      if(msgType === 'error'){
        opt.backgroundColor = '#b20000';
        opt.duration = 7000;
      }
      if(duration){
        opt.duration = duration;
      }

      Toastify(opt).showToast();
    },
    startup: function(){
      App.authClient = new IAMFlybits.oauth2PKCE.Client({
        spHost: App.store.state.config.HOST,
        projectID: App.store.state.config.PROJECTID,
        clientID: App.store.state.config.CLIENTID,
        appCallbackURL: App.store.state.config.APPHOST + '/' + 
                        App.store.state.config.res.AUTHCALLBACK
      });

      App.cache = new window.localforage.createInstance({
        name: App.store.state.config.store.USERDB
      });

      var resolvedHost = document.referrer && document.referrer.indexOf('.development.') > -1? 'https://api.development.flybits.com': App.store.state.config.HOST; 

      Flybits.init({
        HOST: resolvedHost
      }).then(function(){
        deferredReady.resolve();
      });
    },
  };

  var router = App.router = new VueRouter({
    routes: [{
      path: '/',
      name: 'splash',
      component: SplashPage
    },{
      path: '/login',
      name: 'login',
      component: LoginPage
    },{
      path: '/settings',
      name: 'settings',
      component: SettingsPage
    },{
      path: '/auth-callback',
      name: 'authCallback',
      component: AuthCallback
    },{
      path: '/concierge/manage',
      name: 'conciergeManager',
      component: ConciergeManager
    },{
      path: '/content/manage',
      name: 'contentManager',
      component: ContentManager
    },{
      path: '/journey/manage',
      name: 'journeyManage',
      component: ExperienceTemplates
    },{
      path: '/components/manage',
      name: 'componentsManage',
      component: ComponentTemplates
    }]
  });

  var store = App.store = new Vuex.Store({
    modules: {
      config: ConfigStore,
      zone: ZoneStore,
      user: UserStore,
      content: ContentStore,
      component: ComponentStore,
      context: ContextStore
    }
  });

  Vue.config.productionTip = false;
  App.vm = new Vue({
    router: router,
    store: store,
    el: '.container',
    data: function(){
      return {
        isLoaded: false,
        isLoading: false,
        isCFGLoaded: false,
        isDebug: false,
        errorText: '',
        lastSeed: null
      };
    },
    computed: {
    },
    watch: {
    },
    methods: {
      refreshApp: function(){
        window.location.reload();
      }
    },
    mounted: function(){
      this.isLoaded = true;
      window.App = App;
    },
  });
  
  /**
   * Resusing the Vue event emitter interface but keeping it generic so we can
   * swap it out for our favourite event emitter if we ever need to.
   */
  App.vm.on = App.vm.$on;
  App.vm.off = App.vm.$off;
  App.vm.emit = App.vm.$emit;
  App.evt = App.vm;

  var loaderStack = [];
  var loadStart = 0;
  App.evt.on(App.actions.LOADING,function(bool, noDelay){
    if(bool){
      App.vm.isLoading = true;
      if(loaderStack.length <= 0){
        loadStart = new Date().getTime();
      }
      loaderStack.push(true);
    } else if(!bool && loaderStack.length > 1){
      loaderStack.pop();
    } else if(!bool){
      loaderStack.pop();
      var now = new Date().getTime();
      if(now - loadStart < 300 && !noDelay){
        setTimeout(function(){
          App.vm.isLoading = false;
        },300);
      } else{
        App.vm.isLoading = false;
      }
    }
  });

  App.evt.on(App.actions.VIBRATE, function(opt){
    if('vibrate' in navigator){
      var input = opt? opt.pattern || opt.duration || [200,50,200] : [200,50,200];
      navigator.vibrate(input);
    }
  });

  App.evt.on(App.actions.SENDMSG, function(payload){
    window.parent.postMessage(payload, '*');
  });
  window.addEventListener('message', function(evt){
    if(evt.data && evt.data.token){
      console.log('> message received', evt.data);
      App.evt.emit(App.actions.ONMSG, evt.data);
      App.vm.lastSeed = evt.data;
    } else if(!evt.data){
      console.log('> empty message received', evt);
    }
  });

  return App;
})();

/*************************************************/

App.checkVersion();
App.store.dispatch('config/parse').then(function(){
  App.startup();
}).catch(function(e){
  console.log('> initialiaation failed', e);
});
App.util.Obj = (function(){
  var s4 = function(){
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  };
  
  var Obj = {
    guid:function(tuples){
      var str = '';
      if(tuples && tuples > 0){
        for(var i = 0; i < tuples; i++){
          str += str !== ''?'-'+s4():s4();
        }
        return str;
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
    },
    getByStr: function(obj, keyStr){
      // convert indexes to properties
      keyStr = keyStr.replace(/\[(\w+)\]/g, '.$1');
      // strip a leading dot
      keyStr = keyStr.replace(/^\./, '');
      var aKeys = keyStr.split('.');
      for (var i = 0, n = aKeys.length; i < n; ++i) {
        var key = aKeys[i];
        if (key in obj) {
          obj = obj[key];
        } else {
          return;
        }
      }
      return obj;
    },
    setByStr: function(obj, keyStr, val){
      // convert indexes to properties
      keyStr = keyStr.replace(/\[(\w+)\]/g, '.$1');
      // strip a leading dot
      keyStr = keyStr.replace(/^\./, '');
      var aKeys = keyStr.split('.');
      for (var i = 0, n = aKeys.length; i < n; i++) {
        var key = aKeys[i];
        if (key in obj && (i+1) < n) {
          obj = obj[key];
        } else if(!(key in obj) && (i+1) < n){
          obj[key] = {};
          obj = obj[key];
        } else {
          obj[key] = val;
          return val;
        }
      }
    },
    zero2Pad: function(num){
      return ('0'+num).slice(-2);
    },
    removeObject:function(arr,obj,findCallback){
      var index = arr.indexOf(obj);

      if(findCallback){
        var objs = arr.filter(findCallback);
        if(objs.length > 0){
          index = arr.indexOf(objs[0]);
        }
      }

      if(index >= 0){
        return arr.splice(index,1);
      }
      return arr;
    },
    debounce: function(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    difference: function(currentSource, sourceOfTruth){
      var diff = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) < 0){
          diff.push(currentSource[i]);
        }
      }
      return diff;
    },
    intersection: function(currentSource, sourceOfTruth){
      var union = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) > -1){
          union.push(currentSource[i]);
        }
      }
      return union;
    },
    hash: function(str) {
      var hash = 0, i, chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return 'f'+hash;
    },
    replaceAllStr: function(str, search, replacement){
      return str.split(search).join(replacement);
    },
    stringToColour: function(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var colour = '#';
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
      }
      return colour;
    },
    getContrastYIQ: function(hexcolor){
      var r = parseInt(hexcolor.substr(0,2),16);
      var g = parseInt(hexcolor.substr(2,2),16);
      var b = parseInt(hexcolor.substr(4,2),16);
      var yiq = ((r*299)+(g*587)+(b*114))/1000;
      return (yiq >= 128) ? 'black' : 'white';
    },
    hexToRGB: function(hexStr){
      if(hexStr[0] == "#"){
        hexStr = hexStr.slice(1);
      }
      var num = parseInt(hexStr,16);
      var r = (num >> 16);
      var g = (num & 0x0000FF);
      var b = ((num >> 8) & 0x00FF);

      return {
        r: r,
        g: g,
        b: b
      };
    },
    lightenDarkenColor: function(col, amt) {
      var usePound = false;
      if(col[0] == "#"){
        col = col.slice(1);
        usePound = true;
      }
      
      var num = parseInt(col,16);
  
      var r = (num >> 16) + amt;
      if(r > 255){
        r = 255;
      } else if(r < 0){
        r = 0;
      }
  
      var b = ((num >> 8) & 0x00FF) + amt;
      if(b > 255){
        b = 255;
      } else if(b < 0){
        b = 0;
      }
  
      var g = (num & 0x0000FF) + amt;
      if(g > 255){
        g = 255;
      } else if(g < 0){
        g = 0;
      }
  
      return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
    },
    darken: function(hexStr, percent){
      return this.lightenDarkenColor(hexStr, -percent);
    },
    lighten: function(hexStr, percent){
      return this.lightenDarkenColor(hexStr, percent);
    },
    randomInt:function(min,max){
      return Math.floor(Math.random()*(max-min+1)+min);
    },
    toStringParams: function(obj){
      var retObj = {};
      var keys = Object.keys(obj);
      keys.forEach(function(key){
        var val = obj[key];
        if(typeof val === 'object'){
          try{
            retObj[key] = JSON.stringify(val);
          } catch(e){
            retObj[key] = val;
          }
        } else{
          retObj[key] = val;
        }
      });
    
      return retObj;
    }
  };

  Obj.extend = (function(){
    function isMergeableObject(val) {
      var nonNullObject = val && typeof val === 'object';

      return nonNullObject && Object.prototype.toString.call(val) !== '[object RegExp]' && Object.prototype.toString.call(val) !== '[object Date]';
    }

    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }

    function cloneIfNecessary(value, optionsArgument) {
      var clone = optionsArgument && optionsArgument.clone === true;
      return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
    }

    function defaultArrayMerge(target, source, optionsArgument) {
      var destination = target.slice();
      source.forEach(function (e, i) {
        if (typeof destination[i] === 'undefined') {
          destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
          destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
          destination.push(cloneIfNecessary(e, optionsArgument));
        }
      });
      return destination;
    }

    function mergeObject(target, source, optionsArgument) {
      var destination = {};
      if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
          destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
      }
      Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
          destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
          destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
      });
      return destination;
    }

    function deepmerge(target, source, optionsArgument) {
      var array = Array.isArray(source);
      var options = optionsArgument || { arrayMerge: defaultArrayMerge };
      var arrayMerge = options.arrayMerge || defaultArrayMerge;

      if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
      } else {
        return mergeObject(target, source, optionsArgument);
      }
    }

    deepmerge.all = function deepmergeAll(array, optionsArgument) {
      if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements');
      }

      // we are sure there are at least 2 values, so it is safe to have no initial value
      return array.reduce(function (prev, next) {
        return deepmerge(prev, next, optionsArgument);
      });
    };

    return deepmerge;
  })();

  return Obj;
})();
App.util.Api = (function(){
  var defaultAjaxOpts = {
    method: 'GET',
    headers: {}
  };

  var Api = {
    fetch: function(url,opts){
      opts = opts || {};
      opts.respType = opts.respType || 'json';
      var def = new Deferred();
      
      var ajaxOpts = ObjUtil.extend({},defaultAjaxOpts);
      var isJSON = opts.respType === 'json';
      delete opts.respType;
      ObjUtil.extend(ajaxOpts,opts);

      fetch(url,ajaxOpts).then(this.checkResult).then(this.getResultBody)
        .then(function(respObj){
          if(isJSON){
            try{
              respObj.body = Api.parseResponse(respObj.body);
              def.resolve(respObj);
            } catch(e){
              def.reject(new Validation().addError("Request Failed","Unexpected server response.",{
                code: Validation.type.MALFORMED,
              }));
            }
          } else{
            def.resolve(respObj);
          }
        }).catch(function(resp){
          Api.getResultBody(resp).then(function(resultObj){
            var parsedResp = Api.parseErrorMsg(resultObj.body);
            def.reject(new Validation().addError('Request error',parsedResp,{
              serverCode: resp.status
            }));
          });
        });

      return def.promise;
    },
    checkResult: function(resp){
      if(resp.status >= 200 && resp.status < 300){
        return resp;
      }
      throw resp;
    },
    getResultBody: function(resp){
      var def = new Deferred();
      if(resp && resp.text){
        var respHeaders = {};
        resp.headers.forEach(function(val,key){
          respHeaders[key] = val;
        });
        resp.text().then(function(str){
          def.resolve({
            body: str,
            headers: respHeaders
          });
        }).catch(function(e){
          def.reject(e);
        });
      } else{
        def.resolve({
          body: "",
          headers: {}
        });
      }

      return def.promise;
    },
    getResultJSON: function(resp){
      return resp.json();
    },
    htmlEncode:function(value){
      /*global encodeURIComponent*/
      return encodeURIComponent(value);
    },
    htmlDecode:function(str){
      return str.replace(/&#?(\w+);/g, function(match, dec) {
        if(isNaN(dec)) {
          chars = {quot: 34, amp: 38, lt: 60, gt: 62, nbsp: 160, copy: 169, reg: 174, deg: 176, frasl: 47, trade: 8482, euro: 8364, Agrave: 192, Aacute: 193, Acirc: 194, Atilde: 195, Auml: 196, Aring: 197, AElig: 198, Ccedil: 199, Egrave: 200, Eacute: 201, Ecirc: 202, Euml: 203, Igrave: 204, Iacute: 205, Icirc: 206, Iuml: 207, ETH: 208, Ntilde: 209, Ograve: 210, Oacute: 211, Ocirc: 212, Otilde: 213, Ouml: 214, times: 215, Oslash: 216, Ugrave: 217, Uacute: 218, Ucirc: 219, Uuml: 220, Yacute: 221, THORN: 222, szlig: 223, agrave: 224, aacute: 225, acirc: 226, atilde: 227, auml: 228, aring: 229, aelig: 230, ccedil: 231, egrave: 232, eacute: 233, ecirc: 234, euml: 235, igrave: 236, iacute: 237, icirc: 238, iuml: 239, eth: 240, ntilde: 241, ograve: 242, oacute: 243, ocirc: 244, otilde: 245, ouml: 246, divide: 247, oslash: 248, ugrave: 249, uacute: 250, ucirc: 251, uuml: 252, yacute: 253, thorn: 254, yuml: 255, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, permil: 8240, lsaquo: 8249, rsaquo: 8250, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830, oline: 8254, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, hellip: 133, ndash: 150, mdash: 151, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, brkbar: 166, sect: 167, uml: 168, die: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, hibar: 175, plusmn: 177, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, sup1: 185, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, Alpha: 913, alpha: 945, Beta: 914, beta: 946, Gamma: 915, gamma: 947, Delta: 916, delta: 948, Epsilon: 917, epsilon: 949, Zeta: 918, zeta: 950, Eta: 919, eta: 951, Theta: 920, theta: 952, Iota: 921, iota: 953, Kappa: 922, kappa: 954, Lambda: 923, lambda: 955, Mu: 924, mu: 956, Nu: 925, nu: 957, Xi: 926, xi: 958, Omicron: 927, omicron: 959, Pi: 928, pi: 960, Rho: 929, rho: 961, Sigma: 931, sigma: 963, Tau: 932, tau: 964, Upsilon: 933, upsilon: 965, Phi: 934, phi: 966, Chi: 935, chi: 967, Psi: 936, psi: 968, Omega: 937, omega: 969}
          if (chars[dec] !== undefined){
            dec = chars[dec];
          }
        }
        return String.fromCharCode(dec);
      });
    },
    base64Decode: function(str){
      return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    },
    parseResponse: function(rawResponse){
      return JSON.parse(rawResponse,function(key,val){
        if(typeof val === "string"){
          return api.htmlDecode(val);
        }
        return val;
      });
    },
    parseErrorMsg: function(rawResponse){
      try{
        var resp = this.parseResponse(rawResponse);
      } catch(e){
        return "Malformed server response";
      }
      var msg = null;

      if(resp){
        if(resp.error){
          resp = resp.error;
        }
        
        return resp.messageJSON || resp.exceptionMessage || resp.message || "Unexpected error has occurred";
      }

      return msg;
    },
    parseYoutubeID: function(url){
      url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      return undefined !== url[2]?url[2].split(/[^0-9a-z_\-]/i)[0]:url[0];
    }
  };

  return Api;
})();
App.util.Browser = (function(){
  Date.prototype.monthNames = [
    "January", "February", "March",
    "April", "May", "June",
    "July", "August", "September",
    "October", "November", "December"
  ];
  Date.prototype.dayNames = [
    "Sunday", "Monday", "Tuesday",
    "Wednesday", "Thursday", "Friday", "Saturday"
  ];
  Date.prototype.getMonthName = function() {
    return this.monthNames[this.getMonth()];
  };
  Date.prototype.getShortMonthName = function () {
    return this.getMonthName().substr(0, 3);
  };
  Date.prototype.getDayName = function(){
    return this.dayNames[this.getDay()];
  };
  Date.prototype.getShortDayName = function(){
    return this.getDayName().substr(0,3);
  };

  var ObjUtil=window.ObjUtil={s4:function(){return Math.floor((1+Math.random())*65536).toString(16).substring(1)},guid:function(s){var t="js";if(s&&s>0){for(var i=0;i<s;i++)t+="js"!==t?"-"+this.s4():this.s4();return t}return"js"+this.s4()+this.s4()+"-"+this.s4()+"-"+this.s4()+"-"+this.s4()+"-"+this.s4()+this.s4()+this.s4()}};
    var Deferred=function(){var t=function(){var t=this;this.promise=new Promise((function(e,r){t.resolve=e,t.reject=r})),this.then=this.promise.then.bind(this.promise),this.catch=this.promise.catch.bind(this.promise)};return t.settlePromises=t.prototype.settlePromises=function(t){var e=t.map((function(t){return t.then((function(t){return{result:t,status:"resolved"}}),(function(t){return{result:t,status:"rejected"}}))}));return Promise.all(e)},t}();
  
    var ResourceLoader = (function(){
      var RESOURCEURL = '/bin/resources.json';

      var Resource = (function(){
        return {
          createScript: function(url){
            var $inject = document.createElement('script');
            var deferredPromise = new Deferred();
            $inject.setAttribute('type','text/javascript');
            $inject.setAttribute('data-type','inject');
            $inject.setAttribute('src', url);
            $inject.ready = deferredPromise.promise;
            $inject.addEventListener('load', function(evt){
              deferredPromise.resolve();
            });   

            return $inject;
          },
          createModule: function(url) {
            var $inject = document.createElement('script');
            var deferredPromise = new Deferred();

            $inject.setAttribute('type','module');
            
            $inject.setAttribute('src', url);
            $inject.ready = deferredPromise.promise;
            console.log('going sending')
            $inject.addEventListener('load', function(evt){
              console.log('resovling')
              deferredPromise.resolve();
            });   

            return $inject;
          },
          createStyle: function(url){
            var $inject = document.createElement('link');
            var deferredPromise = new Deferred();
            $inject.setAttribute('rel','stylesheet');
            $inject.setAttribute('href', url);
            $inject.ready = deferredPromise.promise;
            $inject.addEventListener('load', function(evt){
              deferredPromise.resolve();
            });   

            return $inject;
          }
        }
      })();

      return {
        loadDependencies: function(){
          var def = new Deferred();

          fetch(RESOURCEURL).then(function(resp){
            if(resp.status !== 200){
              throw new Error('Configuration file not found');
            }
            return resp.json();
          }).then(function(resourceJSON){
            return Deferred.settlePromises([
              ResourceLoader.loadURLs(resourceJSON.scriptURLs),
              ResourceLoader.loadStyleURLs(resourceJSON.styleURLs)
            ]);
          }).then(function(results){
            var failed = results.filter(function(r){
              return r.status === 'rejected';
            })[0];
            
            if(failed){
              def.reject(failed.result);
            } else{
              def.resolve();
            }
          });

          return def.promise;
        },
        loadModule: function(url) {
          var $body = document.querySelector('body');
          var res = Resource.createModule(url)
          $body.prepend(res)
          return Deferred.settlePromises([res.ready])
           
        },
        loadURLs: function(urlArr){
          if(!urlArr || !Array.isArray(urlArr)){
            console.error('Invalid resource list');
          }
          var $body = document.querySelector('body');
          var promises = [];
          urlArr.map(function(url){
            return Resource.createScript(url);
          }).forEach(function(res){
            promises.push(res.ready);
            $body.append(res);
          });

          return Deferred.settlePromises(promises);
        },
        loadStyleURLs: function(urlArr){
          if(!urlArr || !Array.isArray(urlArr)){
            console.error('Invalid resource list');
          }
          var promises = [];
          urlArr.forEach(function(url){
            promises.push(ResourceLoader.loadStyleURL(url));
          });

          return Deferred.settlePromises(promises);
        },
        loadStyleURL: function(url){
          var $head = document.head;
          var $inject = Resource.createStyle(url);
          $head.append($inject);
          return $inject.ready;
        },
        loadStyleStr: function(id, str){
          console.log(id, str)
          var $head = document.head;
          var $inject = document.createElement('style');
          $inject.setAttribute('data-type', id);
          $inject.setAttribute('key', id);
          $inject.innerHTML = str;
          $head.append($inject);
          return Promise.resolve();
        }
      }
    })();

  return {
    ResourceLoader: ResourceLoader,
    getCookie: function(key) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + key + "=");
      if (parts.length == 2) {
        return parts.pop().split(";").shift();
      } else{
        return null;
      }
    },
    setCookie: function(key,value,expiryDateObj){
      var expires = "";
      if (expiryDateObj) {
        expires = "; expires=" + expiryDateObj.toGMTString();
      }
      document.cookie = key + "=" + value + expires + "; path=/";
    },
    getURLParam:function(name, uri) {
      uri = uri || window.location.href;
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(uri);
      if (results === null)
        return "";
      else
        return results[1];
    },
    toURLParamString: function(obj){
      var objKeys = Object.keys(obj);
      var str = '?';
      var keyValArr = objKeys.map(function(key){
        return key + '=' + obj[key];
      });
  
      return str + keyValArr.join('&');
    },
    loadImage: function(url){
      var def = new Deferred();
      if(!url){
        return Promise.reject();
      }

      var $body = document.querySelector('body');
      var $img = document.createElement('img');
      $img.style.position = 'absolute';
      $img.style.opacity = 0;
      $img.style.width = '1px';
      $img.style.height = '1px';
      $img.setAttribute('src', url);
      $body.appendChild($img);
      $img.onload = function(){
        $body.removeChild($img);
        def.resolve();
      };

      return def.promise;
    },
    saveAs: function(str, filename){
      str = encodeURIComponent(str);

      var $link = document.createElement('a');
      $link.style.position = 'absolute';
      $link.style.width = '1px';
      $link.style.height = '1px';
      $link.style.opacity = '0';
      
      var $body = document.querySelector('body');
      
      $link.setAttribute('download', filename);
      $link.setAttribute('href', 'data:application/octet-stream,'+ str);

      $body.appendChild($link);

      $link.click();
    }
  };
})();
App.util.Content = (function(){
  
  var Content = {
    flattenLocales: function(obj){
      var view = this;
      var keys = Object.keys(obj);
      keys.forEach(function(key){
        if(key === 'localizations'){
          var localeObj = obj.localizations && obj.localizations.en?obj.localizations.en:null;
          if(localeObj){
            Object.assign(obj, localeObj);
          }
        } else if(typeof obj[key] === 'object' && !Array.isArray(obj[key])){
          Content.flattenLocales(obj[key]);
        } else if(Array.isArray(obj[key]) && typeof obj[key][0] === 'object'){
          obj[key].forEach(function(o){
            Content.flattenLocales(o);
          });
        }
      });
    },
    /**
     * @todo account for object arrays and how many objects exist in the data cause this only goes through the schema
     * @todo account for primitive arrays
     * @param {Flybits.ContentTemplate} template 
     * @returns 
     */
    getSchemaFieldList: function(template, dataObj){
      var list = [];
      var recursiveAssembly = function(fields, parentKey, parentName, parentType){
        fields.forEach(function(field, index){
          var curKey = field.key;
          var isParentArray = parentType === 'array';
          var arrLength = dataObj && isParentArray && App.util.Obj.getByStr(dataObj,parentKey)?App.util.Obj.getByStr(dataObj,parentKey).length:0;
          
          // no need to account for localizations because the c5 wrapper will flatten locales based on device locale and not pass them to the renderer.
          
          if(isParentArray){
            if(field.type === 'object'){
              for(let i = 0; i < arrLength; i++){
                curKey = parentKey + '['+i+'].' + field.key;
                let name = parentName + '['+i+'] ❱ ' + field.displayName;
                recursiveAssembly(field.fields, curKey, name, field.type);  
              }
            } else{
              for(let e = 0; e < arrLength; e++){
                curKey = 'data.'+parentKey+'['+e+'].'+ curKey;
                let name = parentName + '['+e+'] ❱ ' + field.displayName;
                list.push({
                  key: curKey,
                  name: name,
                  type: field.type,
                  uiType: field.uiType,
                  isRequired: field.isRequired,
                });  
              }
            }
          } else{
            if(parentKey){
              curKey = parentKey + '.' + field.key
            }
            if(field.type === 'object'){
              recursiveAssembly(field.fields, curKey, field.displayName, field.type);
            } else if(field.type === 'array' && field.subType === 'object'){
              var name = parentName?parentName+' ❱ '+field.displayName:field.displayName;
              recursiveAssembly(field.fields, curKey, name, field.type);
            } else{
              curKey = 'data.'+ curKey;
              var name = parentName?parentName+' ❱ '+field.displayName:field.displayName;
              list.push({
                key: curKey,
                name: name,
                type: field.type,
                uiType: field.uiType,
                isRequired: field.isRequired,
              });
            } 
          }
        });
      };
      recursiveAssembly(template.schema);
      return list.sort(function(fieldA, fieldB){
        const nameA = fieldA.name.toUpperCase();
        const nameB = fieldB.name.toUpperCase();
        if(nameA < nameB){
          return -1;
        }
        if(nameA > nameB){
          return 1;
        }

        return 0;
      });
    },
    setUI: function(content, templateType){
      var uiTemplate = App.store.state.component.uiTemplates.filter(function(template){
        return template.key.indexOf(templateType) > -1 ||
               templateType.indexOf(template.key) > -1;
      })[0];
      
      if(uiTemplate){
        content.defaultUI.layoutHTML = uiTemplate.defaultUI.html;
        content.defaultUI.styleCSS = uiTemplate.defaultUI.css;
        
        content.detailsUI.layoutHTML = uiTemplate.detailsUI.html;
        content.detailsUI.styleCSS = uiTemplate.detailsUI.css;
      } else{
        console.log('> no UI template for content template type:', templateType);
      }
    }
  };

  return Content;
})();
})(window, document);